(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[96456],{

/***/ 45146:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course/[slug]/[courseUID]",
      function () {
        return __webpack_require__(4065);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wO": function() { return /* binding */ getCourseDemoClassesKey; },
/* harmony export */   "yT": function() { return /* binding */ getBatchDemoClassesKey; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);




var getBatchDemoClassesKey = function(batchUID) {
    return "v2/batch/".concat(batchUID, "/demo-class/");
};
var getCourseDemoClassesKey = function(courseUID) {
    return "v1/uplus/".concat(courseUID, "/demo-class/");
};
var useDemoClasses = function(key) {
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key), tmp = _ref.data, ref = tmp === void 0 ? {} : tmp, demoClasses = ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        key: key,
        demoClasses: demoClasses
    }, rest), {
        isError: rest.isError || !!(demoClasses === null || demoClasses === void 0 ? void 0 : demoClasses.errorCode)
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (useDemoClasses);


/***/ }),

/***/ 95792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getKey; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68826);
/* harmony import */ var _api_hooks_course_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27012);
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59375);
/* harmony import */ var _api_fetchers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19982);









var courseMiddleware = function(useSWRNext) {
    return function(key, fetcher, config) {
        var ref;
        var swr = useSWRNext(key, fetcher, config);
        var processedCourseData = ((ref = swr.data) === null || ref === void 0 ? void 0 : ref.processed) ? swr.data : (0,_api_hooks_course_utils__WEBPACK_IMPORTED_MODULE_2__/* .processCourseData */ .up)(swr.data);
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, swr), {
            data: processedCourseData
        });
    };
};
var getKey = function(courseUID) {
    return "v1/collection/".concat(courseUID, "/");
};
var useCourseInfo = function(courseUID) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        revalidateOnMount: false,
        fallbackData: undefined
    };
    var key = getKey(courseUID);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(key, {}, {
        use: [
            courseMiddleware
        ],
        revalidateOnMount: options.revalidateOnMount,
        fallbackData: options.fallbackData
    }), course = _ref.data, isValidating = _ref.isValidating, internalMutate = _ref.mutate, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, [
        "data",
        "isValidating",
        "mutate"
    ]);
    var onToggleEnroll = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var sendEmail, prodigyKey, _args = arguments;
            return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        sendEmail = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false, prodigyKey = _args.length > 1 && _args[1] !== void 0 ? _args[1] : null;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,_api_fetchers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("v2/uplus/programmes/".concat(courseUID, "/save/"), {
                            requestType: "POST",
                            body: {
                                enroll: !course.isEnrolled,
                                send_email: sendEmail,
                                prodigy_key: prodigyKey
                            }
                        });
                    case 4:
                        _ctx.next = 6;
                        return internalMutate();
                    case 6:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: {
                                message: "Unable to ".concat(!course.isEnrolled ? "enroll" : "un-enroll", ". Please try again!")
                            }
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function onToggleEnroll() {
            return _ref.apply(this, arguments);
        };
    }();
    var mutate = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data;
            return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return internalMutate();
                    case 3:
                        data = _ctx.sent;
                        return _ctx.abrupt("return", (0,_api_hooks_course_utils__WEBPACK_IMPORTED_MODULE_2__/* .processCourseData */ .up)(data));
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: {
                                message: "Unable to fetch course. Please try again!"
                            }
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function mutate() {
            return _ref.apply(this, arguments);
        };
    }();
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        key: key,
        course: course || _constants_empty__WEBPACK_IMPORTED_MODULE_3__/* .emptyObject */ .FD,
        isValidating: isValidating,
        mutate: mutate
    }, rest), {
        onToggleEnroll: onToggleEnroll
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useCourseInfo);


/***/ }),

/***/ 19482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ PIP_ERROR_CODE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73060);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _auth_useMyInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85780);






var PIP_ERROR_CODE = "E5222";
var usePartPaymentStatus = function(goalUID) {
    var isLoggedIn = (0,_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_3__/* .getIsLoggedIn */ .M7);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(goalUID && isLoggedIn ? "v1/subscriptions/pay_in_parts_subscription_details?goal_uid=".concat(goalUID) : null), data = _ref.data, error = _ref.isError, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, [
        "data",
        "isError"
    ]);
    var partPaymentStatus = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (data) return data;
        if ((error === null || error === void 0 ? void 0 : error.error_code) === PIP_ERROR_CODE) return error;
        return null;
    }, [
        data,
        error
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        partPaymentStatus: partPaymentStatus
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePartPaymentStatus);


/***/ }),

/***/ 92588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_0__);


var OneLinkSmartScript = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
        id: "appsflyer-onelink",
        src: "".concat("https://static.uacdn.net/production/_next", "/static/onelink-smart-script-V2.js"),
        type: "text/javascript",
        strategy: "beforeInteractive"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OneLinkSmartScript);


/***/ }),

/***/ 1113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DemoClasses_DemoClasses; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/batch/useDemoClasses.js
var useDemoClasses = __webpack_require__(35044);
// EXTERNAL MODULE: ./src/components/Container/LearnerClass/utils.js
var utils = __webpack_require__(25683);
// EXTERNAL MODULE: ./src/models/Item.js
var Item = __webpack_require__(46571);
// EXTERNAL MODULE: ./node_modules/aquilla/core/organisms/ClassCard/index.js
var ClassCard = __webpack_require__(22066);
// EXTERNAL MODULE: ./src/components/Base/Link/Link.jsx
var Link = __webpack_require__(76356);
// EXTERNAL MODULE: ./node_modules/aquilla/core/atoms/Typography/index.js
var Typography = __webpack_require__(82353);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/utils/abHelper.js
var abHelper = __webpack_require__(76226);
// EXTERNAL MODULE: ./src/api/fetchers/experiments/index.js
var experiments = __webpack_require__(97163);
// EXTERNAL MODULE: ./src/stores/experiments.js
var stores_experiments = __webpack_require__(19271);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
// EXTERNAL MODULE: ./src/stores/selectors/experiments.js
var selectors_experiments = __webpack_require__(78758);
// EXTERNAL MODULE: ./src/utils/cookies.js
var cookies = __webpack_require__(18113);
// EXTERNAL MODULE: ./src/utils/session/validateAndSetSessionId.ts
var validateAndSetSessionId = __webpack_require__(32415);
;// CONCATENATED MODULE: ./src/hooks/experiments/useDemoClassesExperiment.js









var useDemoClassesExperiment = function(param) {
    var goalUID = param.goalUID;
    var isFreeUser = (0,useMyInfo/* default */.Z)((0,auth/* getIsFreeUser */.tj)(goalUID));
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var accessToken = (0,cookies/* readCookie */.vQ)("accessToken");
    var experimentVariation = (0,stores_experiments/* default */.ZP)((0,selectors_experiments/* getExperimentVariation */.d)("demo_classes_component_web"));
    (0,react.useEffect)(function() {
        if (!accessToken || accessToken && isLoggedIn && isFreeUser) {
            (0,validateAndSetSessionId/* default */.ZP)();
            var deviceID = cookies/* default.readCookie */.ZP.readCookie(validateAndSetSessionId/* DEVICE_ID_COOKIE_NAME */.CR);
            (0,experiments/* fetchABExperimentData */.d)("demo_classes_component_web", abHelper/* abProxyJWT */.q_, deviceID);
        } else if (isLoggedIn) {
            (0,stores_experiments/* setExperimentVariation */.Wb)("demo_classes_component_web", null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accessToken,
        isFreeUser,
        isLoggedIn
    ]);
    var isDemoClassExperiment = experimentVariation && experimentVariation === abHelper/* abVariations.TEST_1 */.WS.TEST_1;
    return isDemoClassExperiment;
};
/* harmony default export */ var experiments_useDemoClassesExperiment = (useDemoClassesExperiment);

// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/stores/AppCommonData.jsx + 1 modules
var AppCommonData = __webpack_require__(83995);
// EXTERNAL MODULE: ./src/stores/selectors/common.js
var common = __webpack_require__(43578);
// EXTERNAL MODULE: ./node_modules/aquilla/core/molecules/Carousel/index.js
var Carousel = __webpack_require__(54570);
;// CONCATENATED MODULE: ./src/components/Container/Batch/DemoClasses/NewCarousel.jsx





var OuterContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e13s7t9b0",
    label: "OuterContainer"
})("position:relative;");
var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e13s7t9b1",
    label: "Container"
})("overflow:hidden;position:relative;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{overflow:scroll;&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;}");
var CarouselWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e13s7t9b2",
    label: "CarouselWrapper"
})("display:flex;gap:16px;transition:transform linear 0.3s;transform:translateX(0px);");
var CarouselItem = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e13s7t9b3",
    label: "CarouselItem"
})("flex-shrink:0;");
var RightBlur = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e13s7t9b4",
    label: "RightBlur"
})("position:absolute;width:17%;height:100%;right:0px;bottom:-0.2px;background:linear-gradient(\n    270deg,#fcfcfc 0.39%,rgba(252,252,252,0) 100%\n  );z-index:2;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{display:none;}");
var StyledArrowButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Carousel/* ArrowButton */.b4, {
    target: "e13s7t9b5",
    label: "StyledArrowButton"
})("z-index:2;position:absolute;top:50%;left:", function(props) {
    return props.type === "prev" ? "0" : "initial";
}, ";right:", function(props) {
    return props.type === "next" ? "0" : "initial";
}, ";border:1px solid var(--color-i-divider);transform:", function(props) {
    return props.type === "next" ? "translate(50%, -50%)" : "translate(-50%, -50%)";
}, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{display:none;}");
var DemoClassesCarousel = function(param) {
    var children = param.children;
    var carouselRef = (0,react.useRef)(null);
    var carouselItemRef = (0,react.useRef)(null);
    var carouselItemWidth = (0,react.useRef)(0);
    var postRemainigCarouselLength = (0,react.useRef)(0);
    var preRemainigCarouselLength = (0,react.useRef)(0);
    var containerRef = (0,react.useRef)(null);
    var itemsOnScroll = (0,react.useRef)(2);
    var ref = (0,react.useState)(true), isPrevDisable = ref[0], setPrevDisable = ref[1];
    var ref1 = (0,react.useState)(false), isNextDisable = ref1[0], setNextDisable = ref1[1];
    var getTranslatedLength = function(val) {
        if (!val) return 0;
        return parseInt(val.match(/translateX\(-*\d+px\)/)[0].match(/-*\d+/), 10);
    };
    var handleButtonVisible = function() {
        setNextDisable(postRemainigCarouselLength.current === 0);
        setPrevDisable(preRemainigCarouselLength.current === 0);
    };
    var handleNext = function() {
        var translatedLength = getTranslatedLength(carouselRef.current.style.transform);
        if (postRemainigCarouselLength.current <= 0) return;
        if (postRemainigCarouselLength.current < itemsOnScroll.current * carouselItemWidth.current) {
            carouselRef.current.style.transform = "translateX(".concat(translatedLength - Math.ceil(postRemainigCarouselLength.current / carouselItemWidth.current) * (carouselItemWidth.current + 16), "px)");
            postRemainigCarouselLength.current = 0;
            setPrevDisable(true);
        } else {
            carouselRef.current.style.transform = "translateX(".concat(translatedLength - itemsOnScroll.current * (carouselItemWidth.current + 16), "px)");
            postRemainigCarouselLength.current -= itemsOnScroll.current * (carouselItemWidth.current + 16);
        }
        preRemainigCarouselLength.current = Math.abs(getTranslatedLength(carouselRef.current.style.transform));
        handleButtonVisible();
    };
    var handlePrev = function() {
        var translatedLength = getTranslatedLength(carouselRef.current.style.transform);
        if (preRemainigCarouselLength.current <= 0) return;
        if (Math.abs(preRemainigCarouselLength.current) < itemsOnScroll.current * carouselItemWidth.current) {
            carouselRef.current.style.transform = "translateX(0px)";
            preRemainigCarouselLength.current = 0;
        } else {
            carouselRef.current.style.transform = "translateX(".concat(translatedLength + itemsOnScroll.current * (carouselItemWidth.current + 16), "px)");
            preRemainigCarouselLength.current -= itemsOnScroll.current * (carouselItemWidth.current + 16);
        }
        postRemainigCarouselLength.current = carouselRef.current.scrollWidth - containerRef.current.offsetWidth - preRemainigCarouselLength.current;
        handleButtonVisible();
    };
    (0,react.useEffect)(function() {
        carouselItemWidth.current = carouselItemRef.current.firstChild.offsetWidth;
        postRemainigCarouselLength.current = carouselRef.current.scrollWidth - containerRef.current.offsetWidth;
        itemsOnScroll.current = Math.floor(containerRef.current.offsetWidth / carouselItemWidth.current);
        if (postRemainigCarouselLength.current !== 0 && isNextDisable) setNextDisable(false);
        handleButtonVisible();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OuterContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselWrapper, {
                        ref: carouselRef,
                        children: children.map(function(child, index) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselItem, {
                                ref: index === 0 ? carouselItemRef : null,
                                children: child
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightBlur, {})
                ]
            }),
            !isPrevDisable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrowButton, {
                type: "prev",
                disabled: isPrevDisable,
                onClick: handlePrev
            }),
            !isNextDisable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrowButton, {
                type: "next",
                disabled: isNextDisable,
                onClick: handleNext
            })
        ]
    });
};
/* harmony default export */ var NewCarousel = (DemoClassesCarousel);

;// CONCATENATED MODULE: ./src/components/Container/Batch/DemoClasses/DemoClasses.jsx


















var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e12hgd7f0",
    label: "Wrapper"
})("display:grid;grid-template-columns:repeat(24,1fr);grid-column-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";grid-column:span 24;position:relative;margin-bottom:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:block;grid-column:span 10;grid-template-columns:repeat(10,1fr);margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";}");
var LeftWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e12hgd7f1",
    label: "LeftWrapper"
})("grid-column:2/8;position:sticky;top:235px;z-index:1;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{position:relative;top:0;padding:0;grid-column:span 10;margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";}");
var RightWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e12hgd7f2",
    label: "RightWrapper"
})("grid-column:9/25;grid-template-columns:repeat(2,2fr);grid-column-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";grid-row-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{grid-column:span 10;grid-template-columns:repeat(1,1fr);& > a{grid-column:span 10;margin-bottom:0;}}");
var StyledTypo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Typography/* default */.ZP, {
    target: "e12hgd7f3",
    label: "StyledTypo"
})("font-weight:bold;margin-bottom:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{margin-bottom:2px;}");
var DemoClasses = function(param) {
    var apiKey = param.apiKey, goalUID = param.goalUID;
    var isExperiment = experiments_useDemoClassesExperiment({
        goalUID: goalUID
    });
    var ref = (0,useDemoClasses/* default */.ZP)(apiKey), _demoClasses = ref.demoClasses, demoClasses = _demoClasses === void 0 ? [] : _demoClasses, isError = ref.isError;
    var currentPageName = (0,AppCommonData/* usePageInfo */.TN)(common/* getCurrentPageName */.d6);
    var goalSegmantData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    var handleClassCardClick = function() {
        analytics/* segment.track */.EX.track("Demo Classes Card Clicked", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmantData), {
            last_primary_source: currentPageName,
            last_primary_source_section: "Demo Classes Section"
        }));
    };
    if (!isExperiment || isError || demoClasses.length === 0) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LeftWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypo, {
                        variant: "h5",
                        children: "Demo classes"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Typography/* default */.ZP, {
                        variant: "p2",
                        color: "var(--color-text-secondary)",
                        children: [
                            " ",
                            "Watch free classes by the educators of this batch"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewCarousel, {
                    children: demoClasses.map(function(classInfo) {
                        var ref;
                        if (!classInfo.nextSession) return null;
                        var as = (0,Item/* getLink */.Rg)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, classInfo), {
                            nextTrack: (0,_object_spread/* default */.Z)({}, classInfo.nextSession, (ref = classInfo.nextSession) === null || ref === void 0 ? void 0 : ref.properties)
                        }));
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                            passHref: true,
                            href: as,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                title: "Special class title",
                                topicColor: "#8873FF"
                            }, (0,utils/* formatClassDetail */.q6)({
                                classInfo: classInfo,
                                hideDetailsLine: false,
                                onClick: handleClassCardClick
                            })))
                        }, classInfo.uid);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var DemoClasses_DemoClasses = (DemoClasses);


/***/ }),

/***/ 25683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MB": function() { return /* binding */ Preview; },
/* harmony export */   "Sg": function() { return /* binding */ formatCourse; },
/* harmony export */   "g9": function() { return /* binding */ getDuration; },
/* harmony export */   "q6": function() { return /* binding */ formatClassDetail; },
/* harmony export */   "uQ": function() { return /* binding */ formatPractice; }
/* harmony export */ });
/* unused harmony exports getClassCard, getClassDetailsLine, getCourseThumbnail, getLabel */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35944);
/* harmony import */ var _models_Item__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46571);
/* harmony import */ var aquilla_core_shared_utils_getTextColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57402);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43135);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31309);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56046);
/* harmony import */ var _utils_pushRoute__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(751);
/* harmony import */ var _base_FutureImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56827);
/* harmony import */ var aquilla_core_molecules_IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97985);
/* harmony import */ var aquilla_core_atoms_EducatorThumbnailBackground__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66390);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95934);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97428);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2080);
/* harmony import */ var aquilla_core_atoms_Tag__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8412);
/* harmony import */ var aquilla_icons_actions_Play__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11619);
/* harmony import */ var _events_segmentStorage__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71250);



















var ClassThumbnailWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__["default"])("div", {
    target: "emembii0",
    label: "ClassThumbnailWrapper"
})("position:relative;width:272px;");
var ClassThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__["default"])("div", {
    target: "emembii1",
    label: "ClassThumbnail"
})("position:relative;width:272px;");
var PreviewContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__["default"])("div", {
    target: "emembii2",
    label: "PreviewContainer"
})(_styles_index__WEBPACK_IMPORTED_MODULE_11__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{position:relative;}");
var PreviewWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__["default"])("div", {
    target: "emembii3",
    label: "PreviewWrapper"
})("position:relative;display:inline-flex;cursor:pointer;");
var PlayIconButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__["default"])(aquilla_core_molecules_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    target: "emembii4",
    label: "PlayIconButton"
})("border-radius:50%;position:absolute;bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .Spacings.SPACING_4B */ .t8.BM, ";right:", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .Spacings.SPACING_4B */ .t8.BM, ";border:none;width:56px;height:56px;padding:", function(props) {
    return props.theme.measurements.spacing(7);
}, ";background:", function(param) {
    var $buttonColor = param.$buttonColor, $isLive = param.$isLive;
    return $isLive ? "var(--color-i-red)" : "".concat($buttonColor, "33");
}, ";transition:0.5s;&:hover,&:active,&:focus{background:", function(param) {
    var $buttonColor = param.$buttonColor, $isLive = param.$isLive;
    return $isLive ? "var(--color-i-red)" : "".concat($buttonColor, "33");
}, ";transform:scale(1.1);}", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:40px;height:40px;}svg{color:", function(param) {
    var $buttonColor = param.$buttonColor, $isLive = param.$isLive;
    return $isLive ? "var(--color-i-white)" : "".concat($buttonColor);
}, ";}");
var ImageWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__["default"])("div", {
    target: "emembii5",
    label: "ImageWrapper"
})("width:464px;", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{width:400px;}", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:calc(100vw - 32px);}img{aspect-ratio:16/9;height:unset;", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;}}");
var EduImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__["default"])(_base_FutureImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "emembii6",
    label: "EduImage"
})("object-fit:cover;border-radius:8px;");
var LiveClassTag = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__["default"])(aquilla_core_atoms_Tag__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
    target: "emembii7",
    label: "LiveClassTag"
})("text-transform:uppercase;position:absolute;left:", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .Spacings.SPACING_4B */ .t8.BM, ";bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .Spacings.SPACING_4B */ .t8.BM, ";padding:", function(props) {
    return props.theme.measurements.spacing(2);
}, " ", function(props) {
    return props.theme.measurements.spacing(3);
}, ";");
function getClassCard(coverPhoto, color, width, height) {
    // eslint-disable-next-line func-names, react/display-name
    return function() {
        if (!coverPhoto) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(aquilla_core_atoms_EducatorThumbnailBackground__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            variant: "content-thumbnail-with-person",
            color: color,
            width: width || 272,
            height: height || 156
        });
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ClassThumbnailWrapper, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_base_FutureImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: coverPhoto,
                alt: "",
                height: height || 156,
                width: width || 272
            })
        });
    };
}
var _obj;
var classStatesMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .sessionStates.FUTURE */ .A_.FUTURE, "Upcoming"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .sessionStates.LIVE */ .A_.LIVE, "Live"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .sessionStates.PAST */ .A_.PAST, "Completed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .sessionStates.DORMANT */ .A_.DORMANT, "Dormont"), _obj);
var getClassDetailsLine = function(classInfo) {
    var startsAt = classInfo.startsAt, endsAt = classInfo.endsAt;
    if (!startsAt) return null;
    var startsAtDate = new Date(startsAt);
    var endsAtDate = endsAt ? new Date(endsAt) : null;
    var startsOn = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_10__/* .getDateMonthString */ .$s)(startsAtDate);
    var classDuration = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_10__/* .getHoursMinutesValueFromSeconds */ .mU)((0,_utils_dates__WEBPACK_IMPORTED_MODULE_10__/* .getTimeDifference */ .FU)(startsAtDate, endsAtDate) * 60);
    var dateString = "";
    dateString += "".concat(startsOn, " \u2022 ");
    dateString += classDuration;
    return dateString;
};
function formatClassDetail(param) {
    var classInfo = param.classInfo, _hideViewCount = param.hideViewCount, hideViewCount = _hideViewCount === void 0 ? false : _hideViewCount, _hideDetailsLine = param.hideDetailsLine, hideDetailsLine = _hideDetailsLine === void 0 ? true : _hideDetailsLine, onClick = param.onClick;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var author = classInfo.author, name = classInfo.name, topicGroups = classInfo.topicGroups, languageDisplay = classInfo.languageDisplay, coverPhotoV1 = classInfo.coverPhotoV1, nextSession = classInfo.nextSession, totalViews = classInfo.totalViews;
    var variant = classStatesMap[nextSession === null || nextSession === void 0 ? void 0 : (ref = nextSession.properties) === null || ref === void 0 ? void 0 : ref.state];
    var viewCount = hideViewCount ? null : totalViews || (nextSession === null || nextSession === void 0 ? void 0 : (ref1 = nextSession.properties) === null || ref1 === void 0 ? void 0 : ref1.attendance) || 0;
    var handleOnClick = function() {
        if (onClick) onClick(classInfo);
        var route = {
            href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_4__/* .getLinkPath */ .bc)(classInfo),
            as: (0,_models_Item__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(classInfo)
        };
        (0,_utils_pushRoute__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(route.href, route.as);
    };
    var classDetail = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
        educatorName: "".concat(author.firstName, " ").concat(author.lastName),
        educatorLink: "/@".concat(author.username),
        title: name,
        topicName: (ref2 = topicGroups[0]) === null || ref2 === void 0 ? void 0 : ref2.name,
        topicColor: ((ref3 = topicGroups[0]) === null || ref3 === void 0 ? void 0 : ref3.name) ? (0,aquilla_core_shared_utils_getTextColor__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(((ref4 = topicGroups[0]) === null || ref4 === void 0 ? void 0 : ref4.name[0]) || "") : "#8873FF",
        langLabel: languageDisplay
    }, variant && {
        variant: variant
    }), {
        thumbnail: getClassCard(coverPhotoV1, (0,aquilla_core_shared_utils_getTextColor__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(((ref5 = topicGroups[0]) === null || ref5 === void 0 ? void 0 : ref5.name[0]) || ""))
    }), viewCount && {
        viewCount: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .nFormatter */ .pF)(viewCount, 1)
    }), {
        onClick: handleOnClick,
        detailsLine: hideDetailsLine ? "" : getClassDetailsLine(classInfo)
    });
    return classDetail;
}
// thumbnail for educator
function getCourseThumbnail(coverPhoto) {
    // eslint-disable-next-line func-names, react/display-name
    return function() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ClassThumbnail, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_base_FutureImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: coverPhoto,
                alt: "",
                height: 156,
                width: 272
            })
        });
    };
}
function getLabel(startsAt, endsAt) {
    var today = new Date();
    var startDateRef = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_10__/* .compareDates */ .aN)(today, startsAt);
    var endDateRef = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_10__/* .compareDates */ .aN)(today, endsAt);
    var label = "";
    if (startDateRef > 0) label = "Starts on ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_10__/* .getDateMonthString */ .$s)(startsAt));
    if (startDateRef === 0) label = "Starts today";
    if (startDateRef < 0) label = "In progress";
    if (endDateRef < 0) label = "Ended on ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_10__/* .getDateMonthString */ .$s)(endsAt));
    return label;
}
function formatCourse(course, lpss) {
    var ref, ref1, ref2;
    var name = course.name, languageDisplay = course.languageDisplay, topicGroups = course.topicGroups, author = course.author, coverPhoto = course.coverPhoto, coverPhotoV1 = course.coverPhotoV1, startsAt = course.startsAt, endsAt = course.endsAt;
    var label = getLabel(startsAt, endsAt);
    var handleOnClick = function() {
        // Adding LPSS to segment from label property and deleting it on class exit
        // in case property is not deleted removing it if label is not passed
        if (lpss) _events_segmentStorage__WEBPACK_IMPORTED_MODULE_14__/* ["default"].setItem */ .Z.setItem("lpss", lpss);
        else _events_segmentStorage__WEBPACK_IMPORTED_MODULE_14__/* ["default"].deleteItem */ .Z.deleteItem("lpss");
        var route = {
            href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_4__/* .getLinkPath */ .bc)(course),
            as: (0,_models_Item__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(course)
        };
        (0,_utils_pushRoute__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(route.href, route.as);
    };
    var courseInfo = {
        title: name,
        langLabel: languageDisplay,
        topicName: (ref = topicGroups[0]) === null || ref === void 0 ? void 0 : ref.name,
        educatorName: "".concat(author.firstName, " ").concat(author.lastName),
        educatorLink: "/@".concat(author.username),
        thumbnail: getCourseThumbnail(coverPhotoV1 || coverPhoto),
        detailsLine: label,
        topicColor: ((ref1 = topicGroups[0]) === null || ref1 === void 0 ? void 0 : ref1.name) ? (0,aquilla_core_shared_utils_getTextColor__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(((ref2 = topicGroups[0]) === null || ref2 === void 0 ? void 0 : ref2.name[0]) || "") : "#8873FF",
        onClick: handleOnClick
    };
    return courseInfo;
}
function formatPractice(practice, goalInfo) {
    var name = practice.name, totalQuestionCount = practice.totalQuestionCount, childrenCount = practice.childrenCount;
    var concepts = (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .nFormatter */ .pF)(totalQuestionCount);
    var questions = (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .nFormatter */ .pF)(childrenCount);
    var description = "".concat(concepts, " concepts  \u2022 ").concat(questions, " questions");
    var practiceInfo = {
        title: name,
        description: description,
        href: "/goal/".concat(goalInfo === null || goalInfo === void 0 ? void 0 : goalInfo.slug, "/").concat(goalInfo === null || goalInfo === void 0 ? void 0 : goalInfo.uid, "/practice/topics/").concat(practice === null || practice === void 0 ? void 0 : practice.uid)
    };
    return practiceInfo;
}
var Preview = function(param) {
    var url = param.url, color = param.color, handlePlayCTA = param.handlePlayCTA, isLive = param.isLive, isMobile = param.isMobile, className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(PreviewContainer, {
        className: className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(PreviewWrapper, {
            onClick: handlePlayCTA,
            children: [
                isLive && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(LiveClassTag, {
                    variant: "solid",
                    color: "var(--color-i-red)",
                    size: "small",
                    children: "Live"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(EduImage, {
                        src: url,
                        alt: "edu-image",
                        priority: true,
                        height: 261,
                        width: 464
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(PlayIconButton, {
                    size: "large",
                    $buttonColor: color,
                    $isLive: isLive,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(aquilla_icons_actions_Play__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                        height: isMobile ? 12 : 17,
                        width: isMobile ? 12 : 17
                    })
                })
            ]
        })
    });
};
var getDuration = function(time) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ":";
    var hours = Math.floor(time / 3600);
    var minutes = Math.floor((time - hours * 3600) / 60);
    var seconds = Math.floor(time - hours * 3600 - minutes * 60);
    var formatedTime = "";
    var addSeparator = false;
    if (hours > 0) {
        formatedTime += "".concat(hours);
        addSeparator = true;
    }
    if (minutes > 0 || minutes === 0) {
        if (addSeparator) {
            formatedTime += "".concat(separator);
        }
        formatedTime += minutes > 9 ? "".concat(minutes) : "0".concat(minutes);
        addSeparator = true;
    }
    if (seconds > 0) {
        if (addSeparator) {
            formatedTime += "".concat(separator);
        }
        formatedTime += seconds > 9 ? "".concat(seconds) : "0".concat(seconds);
    }
    if (!formatedTime) {
        return "".concat(time, "s");
    }
    return formatedTime;
};


/***/ }),

/***/ 99465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ greetingTopSpacing; },
/* harmony export */   "Cj": function() { return /* binding */ eventPadding; },
/* harmony export */   "Du": function() { return /* binding */ timelineTopSpacing; },
/* harmony export */   "EV": function() { return /* binding */ GTP_SUBSCRIPTION; },
/* harmony export */   "UA": function() { return /* binding */ PLATFORM_SUBSCRIPTION; },
/* harmony export */   "UI": function() { return /* binding */ plannerItemTypeHeightMap; },
/* harmony export */   "ZL": function() { return /* binding */ dayTitleLeftSpacing; },
/* harmony export */   "cX": function() { return /* binding */ browseTopSpacing; },
/* harmony export */   "eg": function() { return /* binding */ PLUS_SUBSCRIPTION; },
/* harmony export */   "et": function() { return /* binding */ plannerItemTypes; },
/* harmony export */   "iH": function() { return /* binding */ eventHeightMap; },
/* harmony export */   "jb": function() { return /* binding */ classCardHeight; },
/* harmony export */   "z1": function() { return /* binding */ eventTopSpacing; }
/* harmony export */ });
/* unused harmony export daySpacing */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _constants_schedule__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88268);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



var plannerItemTypes = {
    EVENT: "event",
    TIMELINE: "timeline",
    DAY_TITLE: "day_title",
    GREETING: "greeting",
    SUBSCRIPTION_FEEDBACK: "subscription_feedback",
    SUBSCRIPTION_RENEWAL: "renewal_card",
    FEATURE_CARD: "feature_card",
    FEATURE_INTRODUCTION: "feature_introduction",
    FEATURE_AWARENESS: "feature_card",
    BROWSE: "browse",
    SUBSCRIPTION_FEEDBACK_V2: "subscription_feedback_v2",
    FREE_TRIAL_CARD: "trial_subscription",
    SKELETON_LOADER: "skeleton_loader"
};
var daySpacing = 20;
var timelineTopSpacing = 24;
var eventTopSpacing = 24;
var browseTopSpacing = 24;
var greetingTopSpacing = 20;
var classCardHeight = 162;
var dayTitleLeftSpacing = _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_7B */ .t8.d5;
var _obj;
var plannerItemTypeHeightMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.DAY_TITLE, 64), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.TIMELINE, 12 + timelineTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.BROWSE, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.GREETING, 72 + greetingTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_FEEDBACK, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_RENEWAL, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FEATURE_INTRODUCTION, 168 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FEATURE_AWARENESS, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_FEEDBACK_V2, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SKELETON_LOADER, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FREE_TRIAL_CARD, 212 + browseTopSpacing), _obj);
var _obj1;
var eventHeightMap = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.CLASS */ .pt.CLASS, classCardHeight + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.CLASS_WITH_PRACTICE */ .pt.CLASS_WITH_PRACTICE, 222 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.TEST */ .pt.TEST, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.TEST_WITH_EDUCATOR */ .pt.TEST_WITH_EDUCATOR, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.QUIZ */ .pt.QUIZ, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.COMBAT */ .pt.COMBAT, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.LIVE_INTERACTION */ .pt.LIVE_INTERACTION, 98 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.DAILY_PRACTICE_REMINDER */ .pt.DAILY_PRACTICE_REMINDER, 84 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.OPENHOUSE */ .pt.OPENHOUSE, 80 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.OFFLINE_TEST */ .pt.OFFLINE_TEST, 136 + eventTopSpacing), _obj1);
var eventPadding = 16;
var PLUS_SUBSCRIPTION = "plus_subscription";
var PLATFORM_SUBSCRIPTION = "platform_subscription";
var GTP_SUBSCRIPTION = "gtp_subscription";


/***/ }),

/***/ 88322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ DAILY_GOALS_OPTIONS; },
/* harmony export */   "Fj": function() { return /* binding */ DPP_SET_REMINDER_CLICKED; },
/* harmony export */   "G8": function() { return /* binding */ TOOLTIP_MAP; },
/* harmony export */   "Jb": function() { return /* binding */ DPP_COMPLETED; },
/* harmony export */   "Jf": function() { return /* binding */ QUERY_ACTIONS; },
/* harmony export */   "Kd": function() { return /* binding */ MAX_PRACTICE_SESSION_COUNT; },
/* harmony export */   "LJ": function() { return /* binding */ DISLIKE_REASONS; },
/* harmony export */   "Lr": function() { return /* binding */ MIN_QUESTIONS; },
/* harmony export */   "MA": function() { return /* binding */ FEEDBACK_OPTIONS_MAPPING; },
/* harmony export */   "Ny": function() { return /* binding */ MODAL_TYPES; },
/* harmony export */   "R1": function() { return /* binding */ DPP_SET_REMINDER_CARD_VIEWED; },
/* harmony export */   "Sx": function() { return /* binding */ YEAR_FILTER_TYPE; },
/* harmony export */   "Up": function() { return /* binding */ noPrefrenceCode; },
/* harmony export */   "VL": function() { return /* binding */ REVIEW_TYPE; },
/* harmony export */   "Ws": function() { return /* binding */ PRACTICE_TYPE; },
/* harmony export */   "Xg": function() { return /* binding */ TIME_LAPSE_LIMIT; },
/* harmony export */   "Y8": function() { return /* binding */ practiceActionTypes; },
/* harmony export */   "ad": function() { return /* binding */ LANGUAGE; },
/* harmony export */   "cq": function() { return /* binding */ PRACTICE_MIN_QUESTION_NUM; },
/* harmony export */   "gi": function() { return /* binding */ DEFAULT_LANGUAGE_INFO; },
/* harmony export */   "jb": function() { return /* binding */ DEFAULT_DAILY_GOAL; },
/* harmony export */   "ki": function() { return /* binding */ SUBJECTS; },
/* harmony export */   "lz": function() { return /* binding */ DAILY_REMINDER_OPTIONS; },
/* harmony export */   "nI": function() { return /* binding */ PRACTICE_FLOW_TYPE; },
/* harmony export */   "oH": function() { return /* binding */ DPP_INCOMPLETE; },
/* harmony export */   "oZ": function() { return /* binding */ SKIP_REASONS; },
/* harmony export */   "pj": function() { return /* binding */ DEFAULT_TIME; },
/* harmony export */   "qu": function() { return /* binding */ DEFAULT_TIME_IN_TEXT; },
/* harmony export */   "xl": function() { return /* binding */ MAX_QUESTIONS; }
/* harmony export */ });
/* unused harmony exports getHoursOptions, getRoundedGTPPracticeQuestionCount, DPP_PREFERENCES_QUESTION, PRACTICE_SETTINGS_CLICKED */
/* harmony import */ var _constants_practice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11238);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97428);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48821);



var noPrefrenceCode = -1;
var LANGUAGE = {
    ALL: {
        display_name: "All",
        code: 0
    }
};
var DEFAULT_LANGUAGE_INFO = {
    user_preference: 0,
    available_languages: [],
    language_selection_available: false
};
var PRACTICE_TYPE = {
    FULL: 1,
    EACH_TOPIC: 2,
    PYQ: 3,
    TEXTBOOK: 4,
    INCORRECT: 5
};
var PRACTICE_FLOW_TYPE = {
    NORMAL_PRACTICE: "1",
    CLASS_PRACTICE: "2",
    SYLLABUS_PRACTICE: "3",
    AUTO_DPP: "4"
};
var DISLIKE_REASONS = [
    "Mistake in the question/option choices",
    "Mistake in solution",
    "Technical issue",
    "Plagiarism"
];
var YEAR_FILTER_TYPE = {
    ALL: "all-filter"
};
var SKIP_REASONS = [
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIFFICULT_QUESTION */ .X.DIFFICULT_QUESTION,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/thinking-face.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIDNT_UNDERSTAND */ .X.DIDNT_UNDERSTAND,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/confused.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.HAVENT_STUDIED */ .X.HAVENT_STUDIED,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/exclamation-question.svg")
    }
];
var REVIEW_TYPE = {
    POSITIVE: 1,
    NEGATIVE: 2
};
var SUBJECTS = {
    ALL: -1
};
var MAX_QUESTIONS = 30;
var MIN_QUESTIONS = 5;
var FEEDBACK_OPTIONS_MAPPING = {
    POSITIVE: {
        QUALITY_OF_SOLUTIONS: 496,
        QUALITY_OF_QUESTIONS: 497,
        MIX_OF_QUESTIONS: 498,
        INTERFACE: 499,
        SYLLABUS: 500
    },
    NEGATIVE: {
        QUALITY_OF_SOLUTIONS: 501,
        QUALITY_OF_QUESTIONS: 502,
        MIX_OF_QUESTIONS: 503,
        INTERFACE: 504,
        SYLLABUS: 505
    }
};
var DAILY_GOALS_OPTIONS = [
    {
        value: 10,
        label: "10 questions"
    },
    {
        value: 20,
        label: "20 questions"
    },
    {
        value: 30,
        label: "30 questions"
    }
];
var getHoursOptions = function() {
    var options = [];
    var ref = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .generateHours */ .SA)({
        interval: 30
    }), twentyFourHrFormat = ref.twentyFourHrFormat, twelveHrFormat = ref.twelveHrFormat;
    twelveHrFormat.forEach(function(hour, index) {
        options.push({
            value: twentyFourHrFormat[index],
            label: hour
        });
    });
    return options;
};
var DAILY_REMINDER_OPTIONS = getHoursOptions();
var MODAL_TYPES = {
    PRACTICE_REMINDER: "PRACTICE_REMINDER"
};
var QUERY_ACTIONS = {
    SHOW_REMINDER_SETTING: "show_reminder_setting"
};
var TOOLTIP_MAP = {
    TOTAL_QUESTION_LIMIT_REACHED: "Total questions limit reached",
    CANNOT_ADD_MORE_QUESTIONS: "Cannot add more questions",
    NULL: ""
};
var PRACTICE_MIN_QUESTION_NUM = 5;
var getRoundedGTPPracticeQuestionCount = function(count) {
    return Math.floor(count / 100) * 100;
};
var practiceActionTypes = {
    SET_REMINDER_DEFAULT_DATA: "SET_REMINDER_DEFAULT_DATA"
};
var MAX_PRACTICE_SESSION_COUNT = 5;
var TIME_LAPSE_LIMIT = 7;
var DEFAULT_DAILY_GOAL = 10;
var DEFAULT_TIME = "09:00";
var DEFAULT_TIME_IN_TEXT = "09:00 AM";
var DPP_SET_REMINDER_CARD_VIEWED = "DPP - Set Reminder Card Viewed ";
var DPP_SET_REMINDER_CLICKED = "DPP - Set Reminder Clicked";
var DPP_PREFERENCES_QUESTION = "DPP - Preferences Question";
var PRACTICE_SETTINGS_CLICKED = "Practice - Settings Clicked";
var DPP_COMPLETED = 1;
var DPP_INCOMPLETE = 0;


/***/ }),

/***/ 36742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PlusHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _base_Paper_Paper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59485);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58365);
/* harmony import */ var _HeaderNavBar_HeaderNavBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90899);






var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Paper_Paper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "ev9v2uc0",
    label: "Container"
})("grid-column:span 24 / auto;padding:32px 48px;");
var Header = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_HeaderNavBar_HeaderNavBar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ev9v2uc1",
    label: "Header"
})("padding:0;");
var Content = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ev9v2uc2",
    label: "Content"
})("display:flex;justify-content:space-between;margin-top:40px;");
var Thumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "ev9v2uc3",
    label: "Thumbnail"
})("box-sizing:border-box;margin-right:32px;border-radius:8px;transform:scale(1);");
// eslint-disable-next-line react/jsx-props-no-spreading
var RectSkeleton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        variant: "rect"
    }, props));
};
var Language = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(RectSkeleton, {
    target: "ev9v2uc4",
    label: "Language"
})("margin-bottom:8px;");
var Title = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(RectSkeleton, {
    target: "ev9v2uc5",
    label: "Title"
})("margin-bottom:4px;");
var ShortDescription = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(RectSkeleton, {
    target: "ev9v2uc6",
    label: "ShortDescription"
})("margin-top:32px;");
var Description = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ev9v2uc7",
    label: "Description"
})("display:flex;flex-direction:column;");
var Line = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(RectSkeleton, {
    target: "ev9v2uc8",
    label: "Line"
})("margin-top:4px;");
var Buttons = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ev9v2uc9",
    label: "Buttons"
})("display:flex;flex-direction:column;justify-content:center;align-items:center;");
var Subscribe = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(RectSkeleton, {
    target: "ev9v2uc10",
    label: "Subscribe"
})("width:164px;height:46px;margin-bottom:8px;");
var Share = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(Subscribe, {
    target: "ev9v2uc11",
    label: "Share"
})("margin-bottom:0;");
function PlusHeader() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Container, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Header, {
                title: false,
                breadcrumbsCount: 4
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Content, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Thumbnail, {
                        width: 360,
                        height: 180
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Description, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Language, {
                                width: 80,
                                height: 30
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Title, {
                                width: 300,
                                height: 20
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ShortDescription, {
                                width: 420,
                                height: 20
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Line, {
                                width: 420,
                                height: 20
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Buttons, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Subscribe, {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Share, {})
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 90899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58365);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87312);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);
/* harmony import */ var _stores_selectors_darkModeStatusSelectors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57054);
/* harmony import */ var _stores_useDarkModeStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3458);










var HeaderWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e4vaeqn0",
    label: "HeaderWrapper"
})("padding:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_6B */ .t8.BY, " ", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_12B */ .t8.SL, ";background-color:var(--color-base-1);grid-column:span 18;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var BreadCrumbsWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e4vaeqn1",
    label: "BreadCrumbsWrapper"
})("display:flex;");
var StyledSkeleton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "e4vaeqn2",
    label: "StyledSkeleton"
})(function(param) {
    var $isDarkModeOn = param.$isDarkModeOn;
    return $isDarkModeOn && "background-color: var(--color-base-1);";
}, "  border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var RectStyledSkeleton = function(props) {
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledSkeleton, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variant: "rect"
    }, props)));
};
var BackButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(RectStyledSkeleton, {
    target: "e4vaeqn3",
    label: "BackButton"
})("box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), ";margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_3B */ .t8.N, ";");
var BreadCrumb = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(RectStyledSkeleton, {
    target: "e4vaeqn4",
    label: "BreadCrumb"
})("transform:skew(-20deg);height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_8B */ .t8.B3, ";box-shadow:", function(param) {
    var theme = param.theme;
    return (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        yOffset: _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_1B */ .t8.MK,
        blur: _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_4B */ .t8.BM,
        theme: theme
    });
}, ";margin:auto ", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_6 */ .t8.A1, ";");
var Title = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(RectStyledSkeleton, {
    target: "e4vaeqn5",
    label: "Title"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_6B */ .t8.BY, ";");
var HeaderNavBar = function(param) {
    var breadcrumbsCount = param.breadcrumbsCount, className = param.className, title = param.title;
    var isDarkModeOn = (0,_stores_useDarkModeStatus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_stores_selectors_darkModeStatusSelectors__WEBPACK_IMPORTED_MODULE_7__/* .getIsDarkModeOn */ .q1);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(HeaderWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(BreadCrumbsWrapper, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(BackButton, {
                        $isDarkModeOn: isDarkModeOn,
                        width: _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_8B */ .t8.B3,
                        height: 32
                    }),
                    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new Array(breadcrumbsCount).keys()).map(function(item) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(BreadCrumb, {
                            $isDarkModeOn: isDarkModeOn,
                            width: "86px",
                            height: 32
                        }, item);
                    })
                ]
            }),
            title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Title, {
                $isDarkModeOn: isDarkModeOn,
                height: 38
            })
        ]
    });
};
HeaderNavBar.propTypes = {
    breadcrumbsCount: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().number.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool)
};
HeaderNavBar.defaultProps = {
    className: "",
    title: true
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderNavBar);


/***/ }),

/***/ 11238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SKIP_REASONS_MAP; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var SKIP_REASONS_MAP = {
    DIFFICULT_QUESTION: "Difficult Question",
    DIDNT_UNDERSTAND: "Didn't Understand",
    HAVENT_STUDIED: "Haven't studied"
};


/***/ }),

/***/ 88268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JL": function() { return /* binding */ ScheduleItemTypeLabel; },
/* harmony export */   "Tc": function() { return /* binding */ scheduleItemStatus; },
/* harmony export */   "ft": function() { return /* binding */ ScheduleItemStatusLabel; },
/* harmony export */   "hc": function() { return /* binding */ scheduleItemTypes; },
/* harmony export */   "pt": function() { return /* binding */ plannerEventTypes; }
/* harmony export */ });
/* unused harmony export ScheduleItemRankLabel */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);


var scheduleItemStatus = {
    MISSED: 1,
    WATCHED_OR_ATTEMPTED: 2,
    UPCOMING: 3,
    CANCELLED: 4
};
var _obj;
var ScheduleItemStatusLabel = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.MISSED, "missed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.WATCHED_OR_ATTEMPTED, "completed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.UPCOMING, "upcoming"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.CANCELLED, "cancelled"), _obj);
var scheduleItemTypes = {
    CLASS: 1,
    QUIZ: 2,
    COMBAT: 3,
    TEST: 4,
    LIVE_INTERACTION: 5,
    OPENHOUSE: 6,
    DAILY_PRACTICE_REMINDER: 7
};
var _obj1;
var ScheduleItemTypeLabel = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.CLASS, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.CLASS */ .cs.CLASS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.QUIZ, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.QUIZ */ .cs.QUIZ), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.TEST, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.TEST */ .cs.TEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.COMBAT, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.COMBAT */ .cs.COMBAT), _obj1);
var _obj2;
var ScheduleItemRankLabel = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.CLASS, "Lesson"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.QUIZ, "Quiz"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.COMBAT, "Combat"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.TEST, "Test"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.LIVE_INTERACTION, "Live Interaction"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.OPENHOUSE, "Openhouse"), _obj2);
// categorized based on their height
var plannerEventTypes = {
    CLASS: "class",
    CLASS_WITH_PRACTICE: "class_with_practice",
    TEST: "test",
    TEST_WITH_EDUCATOR: "test_with_educator",
    QUIZ: "quiz",
    COMBAT: "combat",
    LIVE_INTERACTION: "live_interaction",
    DAILY_PRACTICE_REMINDER: "daily_practice_reminder",
    OPENHOUSE: "openhouse",
    OFFLINE_TEST: "offline_test"
};


/***/ }),

/***/ 56046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ getTopicGroup; },
/* harmony export */   "Bc": function() { return /* binding */ isSummitClass; },
/* harmony export */   "PN": function() { return /* binding */ isCompleted; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "Zz": function() { return /* binding */ isUpcoming; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "fr": function() { return /* binding */ isOngoing; },
/* harmony export */   "k$": function() { return /* binding */ getInfoString; },
/* harmony export */   "mI": function() { return /* binding */ getDefaultThumbnail; }
/* harmony export */ });
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97428);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43135);
/* harmony import */ var _Item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46571);




var getInfoString = function(course) {
    var liveAt = course.liveAt || course.startsAt;
    if (!liveAt) return "";
    var infoString = "";
    if (course.state === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .courseStates.COMPLETED */ .MZ.COMPLETED) {
        infoString = "".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDateShort */ .ZP.getDateShort(liveAt), " \u2022 ").concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getTimeFormatInShortFormWithoutSecs */ .ZP.getTimeFormatInShortFormWithoutSecs(course.lessonDuration));
    } else if (course.state === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .courseStates.LIVE */ .MZ.LIVE) {
        infoString = "Started on ".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].formatTime */ .ZP.formatTime(liveAt));
    }
    infoString = "Starts on ".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDateShort */ .ZP.getDateShort(liveAt), " \u2022 ").concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].formatTime */ .ZP.formatTime(liveAt));
    return infoString;
};
var isUpcoming = function(date) {
    if (!date) return false;
    var now = new Date();
    return new Date(date).getTime() > now.getTime();
};
var getDefaultThumbnail = function(course) {
    // To not show plus thumbnail if it's a free course
    if ((course.for_plus || course.forPlus) !== false && (course.programme_type || course.programmeType) === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES) {
        return "https://static.uacdn.net/thumbnail/course/testseries-placeholder.png";
    }
    return null;
};
var isOngoing = function(startsAt, endsAt) {
    if (!startsAt || !endsAt) return false;
    var now = new Date();
    return new Date(startsAt).getTime() < now.getTime() && new Date(endsAt).getTime() > now.getTime();
};
var isCompleted = function(date) {
    if (!date) return false;
    var now = new Date();
    return new Date(date).getTime() < now.getTime();
};
var isSummitClass = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return ((ref = data.goal) === null || ref === void 0 ? void 0 : ref.uid) === "DCGBT";
};
function courseModel(course) {
    var ref, ref1, ref2, ref3, ref4;
    var topicGroups = course.topic_groups || [
        course.topic_group
    ];
    var _state;
    var data = {
        uid: course.uid,
        name: course.name,
        isPartOfBatch: course.is_part_of_batch,
        thumbnail: course.cover_photo_v1 || course.thumbnail_v1 || course.thumbnail || course.cover_photo || getDefaultThumbnail(course),
        newThumbnail: course.cover_photo_v1,
        description: course.description || null,
        permalink: course.permalink,
        relativeLink: course.relative_link,
        averageRating: course.avg_rating,
        slug: course.slug,
        isActive: course.is_active,
        totalReviews: course.total_reviews,
        totalRatings: course.total_ratings,
        forPlus: course.for_plus || course.for_subscription,
        forSubscription: course.for_subscription,
        livestreamUrl: course.livestream_url,
        totalTime: course.total_time,
        totalSessionTime: course.total_session_time,
        viewCount: course.view_count,
        savedCount: course.saved_count,
        previewVideo: course.intro_video,
        language: (course === null || course === void 0 ? void 0 : course.language_display) || (course === null || course === void 0 ? void 0 : (ref = course.multiple_language_display) === null || ref === void 0 ? void 0 : ref[0]),
        liveClassCount: course.sessions_count,
        isEnrolled: course.is_enrolled,
        isBookmarked: course.bookmarked,
        isSpecial: course.is_special,
        isIconic: course.is_iconic,
        enrollmentCount: course.enrollment_count,
        secondaryType: course.secondary_type,
        courseType: course.programme_type,
        isLive: course.is_live,
        state: (_state = course.state) !== null && _state !== void 0 ? _state : course.status,
        liveClassesRemaining: course.sessions_remaining,
        itemCount: course.all_item_count || course.item_count,
        lessonsWatched: course.lessons_watched,
        lessonsCompleted: course.lessons_completed,
        startsAt: course.starts_at,
        endsAt: course.ends_at,
        isUpcoming: isUpcoming(course.starts_at),
        isOngoing: isOngoing(course.starts_at, course.ends_at),
        isCompleted: course.is_completed || isCompleted(course.ends_at),
        quizCount: course.all_item_count - course.sessions_count,
        channelDetails: course.channel,
        nextTrack: {
            item: course.next_track || course.next_session || course.next_class || course.next_item
        },
        previousTrack: {
            item: course.previous_session
        },
        authors: course.authors ? course.authors.map(function(author) {
            return {
                user: author
            };
        }) : [
            {
                user: course.author
            }
        ],
        topicGroups: topicGroups ? topicGroups.map(function(topicGroup) {
            return {
                topology: topicGroup
            };
        }) : null,
        topic: course === null || course === void 0 ? void 0 : (ref1 = course.topic_groups) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name,
        conceptTopology: course === null || course === void 0 ? void 0 : (ref3 = course.concept_topology) === null || ref3 === void 0 ? void 0 : ref3.name,
        coverPhoto: course.cover_photo_v1 || course.cover_photo || course.thumbnail || getDefaultThumbnail(course),
        colorCode: course.color_code,
        goal: course.goal ? {
            topology: course.goal
        } : null,
        topologies: course.topologies ? course.topologies.map(function(topologyItem) {
            return {
                topology: topologyItem
            };
        }) : null,
        goalUid: course.goal_uid || ((ref4 = course.goal) === null || ref4 === void 0 ? void 0 : ref4.uid) || null,
        liveClasses: course.live_classes ? course.live_classes.map(function(itemData) {
            return {
                item: itemData
            };
        }) : null,
        tag: course.tag,
        unLiveUrl: course.unlive_url,
        progress: course.progress,
        conceptLessonCount: course.lesson_count,
        ogImage: course.og_image || null,
        type: course.type || "",
        voiceLanguages: course.voiceLanguages,
        contentSlideLanguages: course.contentSlideLanguages,
        batchGroup: course.batch_group || null,
        totalDPPCount: (course === null || course === void 0 ? void 0 : course.total_practice_dpp_count) || 0,
        queryID: course.queryID,
        requestID: course.requestID,
        index: course.index,
        isRecordedClassesOnlyCourse: !course.is_live_class_present
    };
    if (course.progress) {
        data.progress.nextLessonRelativeLink = course.progress.next_lesson_relative_link;
        data.progress.isCompleted = parseInt(course.progress.percentage, 2) === 100;
    }
    if (course.programme) {
        data.isRecordedClassesOnlyCourse = !course.programme.is_live_class_present;
    }
    data.infoString = getInfoString(data);
    return data;
}
function getEntityData(data) {
    return courseModel(data);
}
var getTopicGroup = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data.topicGroups ? data.topicGroups[0] : null;
};
var getAuthorsName = function(authors) {
    if (!authors) return "";
    var nameText = authors.slice(0, 3).reduce(function(initial, educator, index) {
        if (index === 1) return initial + educator.name;
        if (index < 2 && authors.length === 1) return initial + educator.name;
        if (index < 2) return "".concat(initial, " ").concat(educator.name, ", ");
        return "".concat(initial, " and ").concat(authors.length - 2, " more");
    }, "");
    return nameText;
};
var getLinkPath = function(data) {
    // if course is special
    if (data.isSpecial || data.showAsLesson) {
        var ref, ref1;
        // if a course is special class and inside properties of nextTrack/nextSession uid and relativeLink is available then use class link instead of course link to save redirect from course to class
        var nextTrack = data.nextTrack;
        if (nextTrack && ((nextTrack === null || nextTrack === void 0 ? void 0 : nextTrack.uid) || (nextTrack === null || nextTrack === void 0 ? void 0 : (ref = nextTrack.properties) === null || ref === void 0 ? void 0 : ref.uid) && (nextTrack === null || nextTrack === void 0 ? void 0 : (ref1 = nextTrack.properties) === null || ref1 === void 0 ? void 0 : ref1.relativeLink))) {
            return "/class/[slug]/[uid]";
        }
        return "/course/[slug]/[courseUID]";
    }
    var type = data.type, forPlus = data.forPlus, courseType = data.courseType;
    // lesson - Free course
    if (!forPlus && data.progress && !data.progress.isCompleted && data.progress.nextLessonRelativeLink) {
        return "/lesson/[lessonSlug]/[lessonUID]";
    }
    // checking whether the passed object is course or item. (item)
    if (type === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .itemTypes.POST */ .cs.POST) {
        // if item and plus item means a class
        if (forPlus) return "/class/[slug]/[uid]";
        return "/lesson/[lessonSlug]/[lessonUID]";
    }
    if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES || courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.HYBRID_TESTSERIES */ .h7.HYBRID_TESTSERIES) {
        return "/test-series/[slug]/[courseUID]/";
    }
    return "/course/[slug]/[courseUID]/";
};
var getLink = function(data) {
    if (data.isSpecial || data.showAsLesson) return (0,_Item__WEBPACK_IMPORTED_MODULE_3__/* .getLink */ .Rg)(data);
    if (!data.forPlus && data.progress && !data.progress.isCompleted && data.progress.nextLessonRelativeLink) {
        return data.progress.nextLessonRelativeLink;
    }
    var slug = data.slug;
    var type = data.type, forPlus = data.forPlus, courseType = data.courseType;
    if (!slug) {
        var ref;
        var courseName = (ref = data.name) === null || ref === void 0 ? void 0 : ref.replace(/\/|\\/g, " ");
        slug = _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStringWordsJoinedWith */ .ZP.getStringWordsJoinedWith(courseName, "-");
    }
    if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES || courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.HYBRID_TESTSERIES */ .h7.HYBRID_TESTSERIES) {
        return "/test-series/".concat(slug, "/").concat(data.uid);
    }
    return "/".concat(type === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .itemTypes.POST */ .cs.POST ? forPlus && "class" || "lesson" : "course", "/").concat(slug, "/").concat(data.uid);
};
var course = {
    Course: courseModel,
    getEntityData: getEntityData,
    getAuthorsName: getAuthorsName,
    getTopicGroup: getTopicGroup,
    getLink: getLink,
    getLinkPath: getLinkPath,
    isSummitClass: isSummitClass
};
/* harmony default export */ __webpack_exports__["ZP"] = (course);


/***/ }),

/***/ 34482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ getTopicLinkHref; },
/* harmony export */   "EN": function() { return /* binding */ getSpecialClassesLinkHref; },
/* harmony export */   "Ho": function() { return /* binding */ getHrefAndAsOfAFreeCourse; },
/* harmony export */   "Hw": function() { return /* binding */ getLinkHref; },
/* harmony export */   "Lb": function() { return /* binding */ getSpecialClassesLink; },
/* harmony export */   "Po": function() { return /* binding */ getSpecialClassesAllLink; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "TW": function() { return /* binding */ getCoursesHref; },
/* harmony export */   "UP": function() { return /* binding */ getBrowseLink; },
/* harmony export */   "_Y": function() { return /* binding */ getYoutubeLessonLink; },
/* harmony export */   "b4": function() { return /* binding */ getCoursesAsPath; },
/* harmony export */   "bU": function() { return /* binding */ getYoutubeCourseLink; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "dF": function() { return /* binding */ getTopicListLink; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "pA": function() { return /* binding */ getTopicLink; },
/* harmony export */   "s3": function() { return /* binding */ getTopicListHref; },
/* harmony export */   "v9": function() { return /* binding */ getGtpFreeClassesAllLink; },
/* harmony export */   "vX": function() { return /* binding */ getHrefAndAsOfSaved; },
/* harmony export */   "vx": function() { return /* binding */ getPannerLink; },
/* harmony export */   "yb": function() { return /* binding */ getTopologyName; }
/* harmony export */ });
/* unused harmony exports topologyModal, getBrowseLinkAs, getBrowseLinkHref, getPlannerLinkAs, plannerLink */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);



function topologyModal(topology) {
    var ref;
    // window map
    // "today": 0,
    // "tomorrow": 1,
    // "this week": 2,
    // "in 15 days": 3,
    // "yesterday": -1,
    // "last week": -2,
    // "15 days ago": -3,
    return {
        uid: topology.uid,
        name: topology.name,
        permalink: topology.permalink,
        relativeLink: topology.relative_link,
        goalSlug: topology.slug,
        title: topology.title,
        coursesCount: topology.courses_count || topology.item_count || topology.count || topology.plus_course_count || topology.course_count || 0,
        upcomingCoursesCount: topology.upcoming_count || 0,
        upcomingCoursesThisMonth: topology.upcoming_this_month || 0,
        enrolledCoursesCount: topology.enrolled_count || 0,
        totalSubItem: topology.total_subItem || 0,
        progress: topology.progress || 0,
        color: topology.color,
        plusCourseCount: topology.plusCourseCount || topology.total_count || 0,
        colorCode: topology.color_code,
        level: topology.level,
        fullName: topology.title,
        icon: topology.icon,
        children: topology.children,
        slug: topology.slug || (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .getStringWordsJoinedWith */ .kL)(topology.name, "-"),
        parent: topology.parent,
        isPracticeAvailable: topology.is_practice_session,
        isPlusAvailable: topology.is_plus_available,
        isFreeUnavailable: topology.is_free_unavailable,
        language: topology.language || null,
        ogImage: topology.og_image || null,
        window: topology.window,
        windowCount: topology.window_count,
        selfDataFetched: topology.selfDataFetched || false,
        tags: topology.tags,
        isNoTestGoal: !!((ref = topology.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return (tag === null || tag === void 0 ? void 0 : tag.name) === "NON_TEST_PREP";
        })),
        isIconicAvailable: topology.is_iconic_available,
        externalApps: topology.external_apps_available,
        isSyllabusV1Enabled: topology.is_syllabus_v1_enabled,
        isPlatformGoal: topology.is_platform_goal || false,
        goalLevelOnboarding: {
            isAvailable: topology.is_goal_onboarding_available || false,
            status: topology.user_onboarding_status || null,
            hideNudge: false
        },
        isLeaderdboardMetaInfoAvailable: topology.is_leaderdboard_meta_info_available,
        leaderboardFilters: topology.leaderboard_filters,
        leaderboardScreenMetaInfo: topology.leaderboard_screen_meta_info,
        isCatalogueFeatureAvailable: topology.is_catalogue_feature_available || false,
        isK12: topology.is_k12_goal || false,
        isUaIconGoal: topology.is_ua_icon_goal || false,
        isRecordedGoal: topology.is_recorded_goal,
        isCentreAvailable: topology.is_centre_available
    };
}
function getEntityData(data) {
    return topologyModal(data);
}
var getLink = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid);
};
var getBrowseLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/browse");
};
var getBrowseLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/browse";
};
var getBrowseLink = function(data) {
    return {
        as: getBrowseLinkAs(data),
        href: getBrowseLinkHref()
    };
};
var getPlannerLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/planner");
};
var plannerLink = "/goal/[goalSlug]/[goalUID]/planner";
var getPannerLink = function(data) {
    return {
        as: getPlannerLinkAs(data),
        href: plannerLink
    };
};
/**
 * Retuns link href of a generic goal
 * @returns string pattern of a generic goal href
 */ var getLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]";
};
var getTopicLink = function(topic, goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topic/").concat(topic.uid);
};
var getTopicLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getTopicListLink = function(goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topics");
};
var getTopicListHref = function() {
    return "/goal/goalSlug/goalUID/topics";
};
var getLinkPath = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getSpecialClassesLink = function(data) {
    return "".concat(getLink(data), "/classes");
};
var getSpecialClassesLinkHref = function() {
    return "".concat(getLinkHref(), "/classes");
};
var getSpecialClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes",
        as: "".concat(getLink(data), "/classes")
    };
};
var getGtpFreeClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes/[type]",
        as: "".concat(getLink(data), "/classes/all_classes")
    };
};
var getYoutubeCourseLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]",
        as: "/content/p/freecourses/".concat(data.goalUID)
    };
};
var getYoutubeLessonLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]/[courseTitle]/[courseUID]/[lessonUID]",
        as: "/content/p/freecourses/".concat(data.goalUID, "/").concat(data.courseTitle, "/").concat(data.courseUID, "/").concat(data.lessonUID)
    };
};
var getHrefAndAsOfAFreeCourse = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/free-platform",
        as: "".concat(getLink(data), "/free-platform")
    };
};
var getHrefAndAsOfSaved = function(goal) {
    return {
        href: "".concat(getLinkHref(), "/saved"),
        as: "".concat(getLink(goal), "/saved")
    };
};
var getCoursesHref = function() {
    return "".concat(getTopicLinkHref(), "/courses");
};
var getCoursesAsPath = function(goalSlug, goalUID, topicUID) {
    return "".concat(getTopicLink({
        uid: topicUID
    }, {
        slug: goalSlug,
        uid: goalUID
    }), "/courses");
};
var _obj;
var getTopologyName = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CATEGORY */ .OP.CATEGORY, "Category"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GOAL */ .OP.GOAL, "Goal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GROUP */ .OP.GROUP, "Topic Group"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.TOPIC */ .OP.TOPIC, "Topic"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CONCEPT */ .OP.CONCEPT, "Concept"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.SUBCONCEPT */ .OP.SUBCONCEPT, "Subconcept"), _obj);
var topology = {
    Topology: topologyModal,
    getEntityData: getEntityData,
    getLink: getLink,
    getLinkHref: getLinkHref,
    getSpecialClassesLink: getSpecialClassesLink,
    getLinkPath: getLinkPath,
    getTopicLink: getTopicLink,
    getTopicListLink: getTopicListLink,
    getSpecialClassesAllLink: getSpecialClassesAllLink,
    getHrefAndAsOfAFreeCourse: getHrefAndAsOfAFreeCourse,
    getTopicListHref: getTopicListHref,
    getSpecialClassesLinkHref: getSpecialClassesLinkHref,
    getTopicLinkHref: getTopicLinkHref,
    getHrefAndAsOfSaved: getHrefAndAsOfSaved,
    getTopologyName: getTopologyName
};
/* harmony default export */ __webpack_exports__["ZP"] = (topology);


/***/ }),

/***/ 81570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HQ": function() { return /* binding */ isLegendEducator; },
/* harmony export */   "Pp": function() { return /* binding */ getFullName; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "ug": function() { return /* binding */ formatFirstName; }
/* harmony export */ });
/* unused harmony export getRelativeLink */
/* harmony import */ var _utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21848);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);


var formatFirstName = function(firstName) {
    return firstName ? firstName.toLocaleString() : "";
};
var getRelativeLink = function(user) {
    var url = "/learner/@".concat(user.username);
    if (user.is_educator || user.is_moderator) url = user.relative_link || "/@".concat(user.username);
    return url;
};
var getFullName = function(firstName, lastName) {
    return "".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(firstName), " ").concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(lastName));
};
function userModel(userData) {
    var user = userData.author_details ? userData.author_details : userData;
    var firstName = user.first_name ? user.first_name.toLocaleString() : "";
    var lastName = user.last_name ? user.last_name : "";
    return {
        firstName: firstName,
        lastName: lastName,
        uid: user.uid,
        isFullStoryUser: user.is_full_story_user,
        name: getFullName(firstName, lastName),
        thumbnail: user.avatar_v1 || user.avatar || null,
        description: user.bio || null,
        permalink: user.permalink,
        relativeLink: getRelativeLink(user),
        averageRating: user.avg_rating,
        username: user.username.toLowerCase() || null,
        referralInfo: user.referral_info,
        followersCount: user.followers_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.followers_count) : null,
        followingCount: user.follows_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.follows_count) : null,
        lifetimeViews: user.lifetime_views ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.lifetime_views) : null,
        starRatings: user.star_ratings ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.star_ratings) : null,
        isFollowing: user.is_following,
        postsCount: user.posts_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.posts_count) : null,
        coursesCount: user.courses_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.courses_count) : null,
        isEducator: user.is_educator,
        isModerator: user.is_moderator,
        isVerifiedEducator: user.is_verified_educator,
        isExEducator: user.is_ex_educator,
        isEmailVerified: user.is_email_verified,
        isPhoneVerified: user.is_phone_verified,
        isProfileFilled: user.is_profile_filled,
        isPlatformEducator: user.is_platform_educator,
        isPlatinumEducator: user.is_platinum_educator,
        dedications: user.dedications,
        topicsDisplay: user.topics_display,
        stats: user.stats,
        phone: user.phone,
        email: user.email,
        state: user.state,
        country: user.country,
        language: user.language,
        canAddPlusCourse: user.can_add_plus_course,
        canAddSpecialClass: user.can_add_special_class,
        verifiedEducatorAt: user.verified_educator_at,
        liveMinutes: user.live_minutes ? Math.round(user.live_minutes / 60) : 0,
        totalWatchMins: user.total_watch_time ? Math.round(user.total_watch_time / 60) : 0,
        credentials: user.credentials,
        languages: user.languages,
        becomeEducatorAt: user.become_educator_at,
        educatorType: user.educator_type,
        educatorTypeV2: user.educator_type_v2,
        knowsAbout: user.knows_about,
        levelInfo: user.level_info || {},
        levelId: user.level_id,
        dateJoined: user.date_joined,
        ogImage: user.og_image || null,
        leaderboardMetaInfo: user.leaderboard_meta_info || null,
        avatarV1: user.avatar_v1 || null,
        avatarV2: user.avatar_v2 || null,
        oldAvatar: user.old_avatar || null,
        fallbackAvatar: user.avatar || null,
        queryID: user.queryID,
        requestID: user.requestID,
        index: user.index
    };
}
function getEntityData(data) {
    return userModel(data);
}
var isLegendEducator = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data.uid === "WO7LDJ3Y2Z" || data.educatorType === 4;
};
var user = {
    User: userModel,
    getEntityData: getEntityData,
    isLegendEducator: isLegendEducator
};
/* harmony default export */ __webpack_exports__["ZP"] = (user);


/***/ }),

/***/ 4065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _courseUID_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/components/Base/Menu/Menu.jsx
var Menu = __webpack_require__(55161);
// EXTERNAL MODULE: ./src/hooks/reduxHooks.js + 1 modules
var reduxHooks = __webpack_require__(88738);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
// EXTERNAL MODULE: ./src/redux/actions/courses.js
var courses = __webpack_require__(5861);
// EXTERNAL MODULE: ./src/components/Skeletons/Course/PlusHeader.jsx
var PlusHeader = __webpack_require__(36742);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(68060);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Base/Paper/Paper.jsx
var Paper = __webpack_require__(59485);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
;// CONCATENATED MODULE: ./src/components/Skeletons/Course/Schedule.jsx






var WeekInfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "efcp8yy0",
    label: "WeekInfoWrapper"
})("grid-column:2/9;position:sticky;top:235px;opacity:", function(param) {
    var isEducatorSide = param.isEducatorSide, notAccessible = param.notAccessible;
    return isEducatorSide ? 1 : notAccessible && 0.5;
}, ";");
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "efcp8yy1",
    label: "Wrapper"
})("display:grid;grid-template-columns:repeat(24,1fr);grid-column-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";grid-column:span 24;margin-top:", function(param) {
    var isBatch = param.isBatch, _showMargin = param.showMargin, showMargin = _showMargin === void 0 ? true : _showMargin;
    return showMargin && (isBatch ? styleConstants/* Spacings.SPACING_16B */.t8.hN : styleConstants/* Spacings.SPACING_10B */.t8.FC);
}, ";margin-bottom:", function(param) {
    var _mb = param.mb, mb = _mb === void 0 ? false : _mb;
    return mb ? styleConstants/* Spacings.SPACING_10B */.t8.FC : styleConstants/* Spacings.SPACING_0B */.t8.NE;
}, ";position:relative;");
var StyledContent = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Paper/* default */.Z, {
    target: "efcp8yy2",
    label: "StyledContent"
})("grid-column:9/25;height:100px;padding:24px;display:flex;align-items:center;justify-content:center;");
var Play = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "efcp8yy3",
    label: "Play"
})();
var PlayIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Skeleton/* default */.Z, {
    target: "efcp8yy4",
    label: "PlayIcon"
})("width:40px;height:40px;margin-right:24px;margin-bottom:8px;");
var Description = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "efcp8yy5",
    label: "Description"
})("width:100%;height:100%;");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Skeleton/* default */.Z, {
    target: "efcp8yy6",
    label: "Title"
})("margin-bottom:8px;");
var weeks = {
    week1: [
        1
    ],
    week2: [
        1,
        2,
        3
    ],
    week3: [
        1,
        2,
        3
    ]
};
var Week = function(param) {
    var index = param.index;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            index === 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WeekInfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                        variant: "rect",
                        width: "50%",
                        height: "15px"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                        variant: "text",
                        width: "75%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContent, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Play, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayIcon, {
                                variant: "circle"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                                variant: "rect",
                                width: "50%",
                                height: "5px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Description, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                variant: "text",
                                width: "75%"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                                variant: "text",
                                width: "75%"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
Week.propTypes = {
    index: (prop_types_default()).number.isRequired
};
var Weeks = function() {
    var week1 = weeks.week1, week2 = weeks.week2, week3 = weeks.week3;
    var renderWeeks = function(info) {
        var mb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, type = arguments.length > 2 ? arguments[2] : void 0;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
            showMargin: false,
            mb: mb,
            type: type,
            children: info.map(function(week) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Week, {
                    index: week
                }, week);
            })
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            renderWeeks(week1, true, "week1"),
            renderWeeks(week2, true, "week2"),
            renderWeeks(week3, true, "week3")
        ]
    });
};
/* harmony default export */ var Schedule = (Weeks);

// EXTERNAL MODULE: ./src/stores/toggleables.js
var toggleables = __webpack_require__(85690);
// EXTERNAL MODULE: ./src/constants/toggleables.js
var constants_toggleables = __webpack_require__(28119);
// EXTERNAL MODULE: ./src/stores/snackbar.js
var snackbar = __webpack_require__(97296);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/components/Base/Dynamic/Dynamic.js + 2 modules
var Dynamic = __webpack_require__(28066);
// EXTERNAL MODULE: ./src/components/Composite/Dialog/Dialog.tsx + 1 modules
var Dialog = __webpack_require__(76920);
// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/hooks/useCourseClassPlayer.js
var useCourseClassPlayer = __webpack_require__(7994);
// EXTERNAL MODULE: ./src/hooks/useAllTypesOfCourseEventProps.js
var useAllTypesOfCourseEventProps = __webpack_require__(96780);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/constants/empty.js
var empty = __webpack_require__(59375);
// EXTERNAL MODULE: ./src/components/Container/DeviceLimitation/useCheckFeatureLimit.ts
var useCheckFeatureLimit = __webpack_require__(22932);
// EXTERNAL MODULE: ./src/types/features.ts
var features = __webpack_require__(36414);
// EXTERNAL MODULE: ./src/redux/selectors/subscription.js
var selectors_subscription = __webpack_require__(83553);
// EXTERNAL MODULE: ./src/redux/selectors/auth.js
var selectors_auth = __webpack_require__(34497);
// EXTERNAL MODULE: ./src/api/selectors/constants.js
var selectors_constants = __webpack_require__(17064);
// EXTERNAL MODULE: ./src/api/hooks/course/useCourseInfo.js
var useCourseInfo = __webpack_require__(95792);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/hooks/useFetch.js
var useFetch = __webpack_require__(68826);
// EXTERNAL MODULE: ./src/utils/api-helper/fetch.js
var fetch = __webpack_require__(5618);
;// CONCATENATED MODULE: ./src/api/hooks/course/useSimilarPlusCourses.js









var getKey = function(courseUID) {
    return "v2/collection/".concat(courseUID, "/similar_courses/");
};
var useSimilarPlusCourses = function(courseUID) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        revalidateOnMount: false,
        fallbackData: undefined
    };
    var store = (0,es/* useStore */.oR)();
    var key = getKey(courseUID);
    var _ref = (0,useFetch/* default */.Z)(key, {}, {
        revalidateOnMount: options.revalidateOnMount,
        fallbackData: options.fallbackData
    }), similarCourses = _ref.data, isValidating = _ref.isValidating, mutate = _ref.mutate, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "data",
        "isValidating",
        "mutate"
    ]);
    var onToggleEnroll = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(similarCourseUID, isEnrolled) {
            var sendEmail, prodigyKey, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        sendEmail = _args.length > 2 && _args[2] !== void 0 ? _args[2] : false, prodigyKey = _args.length > 3 && _args[3] !== void 0 ? _args[3] : null;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,fetch/* default */.Z)("v2/uplus/programmes/".concat(similarCourseUID, "/save/"), {
                            dispatch: store.dispatch,
                            getState: store.getState,
                            requestType: "POST",
                            body: {
                                enroll: isEnrolled,
                                send_email: sendEmail,
                                prodigy_key: prodigyKey
                            }
                        });
                    case 4:
                        _ctx.next = 6;
                        return mutate();
                    case 6:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: {
                                message: "Unable to ".concat(!isEnrolled ? "enroll" : "un-enroll", ". Please try again!")
                            }
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function onToggleEnroll(similarCourseUID, isEnrolled) {
            return _ref.apply(this, arguments);
        };
    }();
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        key: key,
        similarCourses: similarCourses || empty/* emptyObject */.FD,
        isValidating: isValidating,
        mutate: mutate
    }, rest), {
        onToggleEnroll: onToggleEnroll
    });
};
/* harmony default export */ var course_useSimilarPlusCourses = (useSimilarPlusCourses);

;// CONCATENATED MODULE: ./src/api/hooks/course/useRelevantFreeCourses.js




var useRelevantFreeCourses_getKey = function(courseUID) {
    return "v1/collection/".concat(courseUID, "/relevant_courses/");
};
var useRelevantFreeCourses = function(courseUID) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        revalidateOnMount: false,
        selector: null,
        fallbackData: undefined
    };
    var key = useRelevantFreeCourses_getKey(courseUID);
    var _ref = (0,useFetch/* default */.Z)(key, {}, {
        revalidateOnMount: options.revalidateOnMount,
        fallbackData: options.fallbackData
    }), relevantFreeCourses = _ref.data, isValidating = _ref.isValidating, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "data",
        "isValidating"
    ]);
    if (options.selector && typeof options.selector === "function") {
        return options.selector(relevantFreeCourses || empty/* emptyList */.n8);
    }
    return (0,_object_spread/* default */.Z)({
        key: key,
        relevantFreeCourses: relevantFreeCourses || empty/* emptyList */.n8,
        isValidating: isValidating
    }, rest);
};
/* harmony default export */ var course_useRelevantFreeCourses = (useRelevantFreeCourses);

// EXTERNAL MODULE: ./src/api/hooks/course/utils.js
var utils = __webpack_require__(27012);
;// CONCATENATED MODULE: ./src/api/hooks/course/useLessonList.js






var lessonListMiddleware = function(useSWRNext) {
    return function(key, fetcher, config) {
        var ref;
        var swr = useSWRNext(key, fetcher, config);
        var processedprocessLessonListData = ((ref = swr.data) === null || ref === void 0 ? void 0 : ref.processed) ? swr.data : (0,utils/* processLessonList */.jl)(swr.data);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swr), {
            data: processedprocessLessonListData
        });
    };
};
var useLessonList_getKey = function(courseUID) {
    var shouldGetExtraInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return "v2/collection/".concat(courseUID, "/items/?limit=600").concat(shouldGetExtraInfo ? "&extra_info=True" : "");
};
var useLessonList = function(courseUID) {
    var shouldGetExtraInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        revalidateOnMount: false,
        selector: null,
        fallbackData: undefined
    };
    var key = useLessonList_getKey(courseUID, shouldGetExtraInfo);
    var _ref = (0,useFetch/* default */.Z)(key, {}, {
        use: [
            lessonListMiddleware
        ],
        revalidateOnMount: options.revalidateOnMount,
        fallbackData: options.fallbackData
    }), lessonList = _ref.data, isValidating = _ref.isValidating, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "data",
        "isValidating"
    ]);
    if (options.selector && typeof options.selector === "function") {
        return options.selector(lessonList || empty/* emptyObject */.FD);
    }
    return (0,_object_spread/* default */.Z)({
        key: key,
        lessonList: lessonList || empty/* emptyObject */.FD,
        isValidating: isValidating
    }, rest);
};
/* harmony default export */ var course_useLessonList = (useLessonList);

;// CONCATENATED MODULE: ./src/api/hooks/course/useCourseTrack.js






var nextCourseTrackMiddleware = function(useSWRNext) {
    return function(key, fetcher, config) {
        var ref;
        var swr = useSWRNext(key, fetcher, config);
        var processedNextTrackData = ((ref = swr.data) === null || ref === void 0 ? void 0 : ref.processed) ? swr.data : (0,utils/* processNextTrack */["do"])(swr.data || empty/* emptyObject */.FD);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swr), {
            data: processedNextTrackData
        });
    };
};
var useCourseTrack_getKey = function(courseUID) {
    return "v1/collection/".concat(courseUID, "/next_track/");
};
var useCourseTrack = function(courseUID) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        revalidateOnMount: false,
        selector: null,
        fallbackData: undefined
    };
    var key = useCourseTrack_getKey(courseUID);
    var _ref = (0,useFetch/* default */.Z)(key, {}, {
        use: [
            nextCourseTrackMiddleware
        ],
        revalidateOnMount: options.revalidateOnMount,
        fallbackData: options.fallbackData
    }), courseTrack = _ref.data, isValidating = _ref.isValidating, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "data",
        "isValidating"
    ]);
    if (options.selector && typeof options.selector === "function") {
        return options.selector(courseTrack || empty/* emptyObject */.FD);
    }
    return (0,_object_spread/* default */.Z)({
        key: key,
        courseTrack: courseTrack || empty/* emptyObject */.FD,
        isValidating: isValidating
    }, rest);
};
/* harmony default export */ var course_useCourseTrack = (useCourseTrack);

// EXTERNAL MODULE: ./src/api/hooks/topology/useSelectedGoal.js
var useSelectedGoal = __webpack_require__(96487);
// EXTERNAL MODULE: ./src/api/hooks/useConstants.js
var useConstants = __webpack_require__(79917);
// EXTERNAL MODULE: ./src/hooks/useIsRecordedGoal.js
var useIsRecordedGoal = __webpack_require__(23207);
// EXTERNAL MODULE: ./src/redux/constants/index.js
var redux_constants = __webpack_require__(94336);
;// CONCATENATED MODULE: ./src/api/hooks/auth/useUAM.js



var useUAM_getKey = function(action, resourceType, resourceUid) {
    return "v1/user/check_access/?actions=".concat(action, "&resource=").concat(resourceType, ":").concat(resourceUid);
};
var UAM_ACTIONS = {
    PROGRAMME_VIEW: "Programme:View"
};
var UAM_RESOURCE_TYPES = {
    PROGRAMME: "Programme",
    QUIZ: "QUIZ"
};
var useUAM = function(action, resourceType, resourceUid) {
    var ref;
    var key = useUAM_getKey(action, resourceType, resourceUid);
    var _ref = (0,useFetch/* default */.Z)(resourceUid ? key : null), data = _ref.data, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "data"
    ]);
    return (0,_object_spread/* default */.Z)({
        key: key,
        hasAccess: !!(data === null || data === void 0 ? void 0 : (ref = data.actionAllowed) === null || ref === void 0 ? void 0 : ref[action.toLowerCase()]),
        data: data
    }, rest);
};
/* harmony default export */ var auth_useUAM = (useUAM);

// EXTERNAL MODULE: ./src/components/Container/Batch/DemoClasses/DemoClasses.jsx + 2 modules
var DemoClasses = __webpack_require__(1113);
// EXTERNAL MODULE: ./src/events/segmentStorage.js
var segmentStorage = __webpack_require__(71250);
// EXTERNAL MODULE: ./src/api/selectors/course.js
var selectors_course = __webpack_require__(61465);
// EXTERNAL MODULE: ./src/api/hooks/batch/useDemoClasses.js
var useDemoClasses = __webpack_require__(35044);
// EXTERNAL MODULE: ./src/components/Container/Batch/utils.js
var Batch_utils = __webpack_require__(73993);
// EXTERNAL MODULE: ./src/components/Container/Course/utils.js
var Course_utils = __webpack_require__(85396);
// EXTERNAL MODULE: ./src/components/Container/Course/PDFDownload.jsx
var PDFDownload = __webpack_require__(62411);
// EXTERNAL MODULE: ./src/components/Base/H6/H6.jsx
var H6 = __webpack_require__(10076);
// EXTERNAL MODULE: ./src/hooks/useFirstRenderSkip.js
var useFirstRenderSkip = __webpack_require__(6858);
// EXTERNAL MODULE: ./src/models/Me.js + 4 modules
var Me = __webpack_require__(92942);
// EXTERNAL MODULE: ./src/utils/dates.js
var dates = __webpack_require__(97428);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/utils/textHelper.js
var textHelper = __webpack_require__(31309);
// EXTERNAL MODULE: ./src/utils/isEmpty.js
var isEmpty = __webpack_require__(29626);
// EXTERNAL MODULE: ./src/redux/selectors/courses.js + 1 modules
var selectors_courses = __webpack_require__(41239);
// EXTERNAL MODULE: ./src/components/Container/Course/Week.jsx + 4 modules
var Course_Week = __webpack_require__(55253);
;// CONCATENATED MODULE: ./src/components/Container/Course/LearnerSideCourseSchdule.jsx





















var SeeAll = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "e19744xx0",
    label: "SeeAll"
})("grid-column:9/25;background-color:var(--color-base-1);color:var(--color-text-primary);height:70px;text-align:center;cursor:pointer;padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{width:100%;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";height:auto;font-size:", styleConstants/* Fonts.SMALL */.F3.HC, ";margin:", styleConstants/* Spacings.SPACING_4B */.t8.BM, " 0;}");
var getThreeWeeks = function(weeks) {
    return (0,_object_spread/* default */.Z)({}, weeks[1] && {
        1: weeks[1]
    }, weeks[2] && {
        2: weeks[2]
    }, weeks[3] && {
        3: weeks[3]
    });
};
var getTenLessons = function() {
    var lessons = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return lessons.slice(0, 10);
};
// TODO: Need to merge with CourseSchedule
// Just for learner side
var LeanerCourseSchdule = function(param) {
    var course = param.course, lessonByWeeks = param.lessonByWeeks, isTestSeries = param.isTestSeries, allLessons = param.allLessons, lessonToResume = param.lessonToResume, liveLesson = param.liveLesson, onItemClick = param.onItemClick, setAnchorEl = param.setAnchorEl, selectedLesson = param.selectedLesson, renewalData = param.renewalData, showByWeek = param.showByWeek, hasDppAccess = param.hasDppAccess;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var courseUID = router.query.courseUID;
    var goalUID = course.goalUid;
    var me = (0,es/* useSelector */.v9)(selectors_auth/* getMe */.jo);
    var ref3 = (0,react.useState)(true), hideFewWeeks = ref3[0], setHideFewWeeks = ref3[1];
    (0,useFirstRenderSkip/* default */.Z)(function() {
        setHideFewWeeks(!(course === null || course === void 0 ? void 0 : course.isEnrolled));
    }, [
        course === null || course === void 0 ? void 0 : course.isEnrolled
    ]);
    var subscription = (0,es/* useSelector */.v9)((0,selectors_subscription/* getPlusSubscriptionInfo */.JL)(goalUID));
    var isSubscribed = (0,Me/* hasActiveSubscriptionToGoal */.Bx)(me, goalUID);
    var isOnlyRecordedClassesPresent = (0,selectors_course/* getIsOnlyRecordedClassesPresent */.a)(course);
    var totalPracticeDPPCount = (0,reduxHooks/* useSelectorToStore */.nZ)((0,selectors_courses/* getTotalPracticeDPPCount */.dr)(courseUID));
    var toggleHideWeeks = function() {
        return setHideFewWeeks(false);
    };
    var showEducatorForLesson = (course === null || course === void 0 ? void 0 : (ref = course.authors) === null || ref === void 0 ? void 0 : ref.length) > 1;
    var getScheduleInfoData = function() {
        var ref, ref1;
        return {
            dateInfo: (0,dates/* getScheduleDateInfo */.D5)((ref = allLessons[0]) === null || ref === void 0 ? void 0 : ref.liveAt, (ref1 = allLessons[allLessons.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.liveAt),
            lessonCountInfo: (0,Course_utils/* getCountInfo */.mU)(course.liveClassCount, course.quizCount, isTestSeries),
            dppCount: totalPracticeDPPCount
        };
    };
    var getWeekInfoData = function(weekNumber) {
        var ref, ref1, ref2, ref3;
        return {
            dateInfo: (0,dates/* getWeekDateInfo */.dJ)((ref = lessonByWeeks[weekNumber].lessons[0]) === null || ref === void 0 ? void 0 : ref.liveAt),
            lessonCountInfo: (0,Course_utils/* getCountInfo */.mU)((ref1 = lessonByWeeks[weekNumber]) === null || ref1 === void 0 ? void 0 : ref1.lessonCount, (ref2 = lessonByWeeks[weekNumber]) === null || ref2 === void 0 ? void 0 : ref2.quizCount, false),
            dppCount: (ref3 = lessonByWeeks[weekNumber]) === null || ref3 === void 0 ? void 0 : ref3.dppCount
        };
    };
    var getCourseInfoForFreeCourse = function() {
        return "".concat((0,textHelper/* pluralize */._6)(course.itemCount, "lesson"), " \u2022 ").concat((0,dates/* getTimeFormatInShortFormWithoutSecs */.ty)(course.totalTime));
    };
    var renderSchedule = function() {
        // TODO: as this is copied from CourseSchedule. Need to checks what this is used for
        var getCardPosition = function() {
            var cardPosition = -1;
            var expiryDate = subscription === null || subscription === void 0 ? void 0 : subscription.expired_at;
            var expiry = expiryDate && new Date(expiryDate);
            if ((0,dates/* compareDates */.aN)(expiryDate, course.endsAt) !== 1) return -1;
            for(var i = 0; i < (allLessons === null || allLessons === void 0 ? void 0 : allLessons.length); i += 1){
                if (expiry < new Date(allLessons[i].liveAt)) {
                    cardPosition = allLessons[i].rank - 1;
                    break;
                }
            }
            return cardPosition;
        };
        var cardPosition = (course === null || course === void 0 ? void 0 : course.forSubscription) ? getCardPosition() : -1;
        if (showByWeek) {
            // show only 3 weeks if not enrolled
            var weeksShown = hideFewWeeks ? getThreeWeeks(lessonByWeeks) : lessonByWeeks;
            return Object.keys(weeksShown).map(function(weekNumber) {
                var ref;
                var weekTitle = "Week ".concat(weekNumber);
                if (!lessonByWeeks[weekNumber]) return null;
                var weekInfo = (0,dates/* getStartAndEndDateOfWeek */.C2)((ref = lessonByWeeks[weekNumber].lessons[0]) === null || ref === void 0 ? void 0 : ref.liveAt, lessonByWeeks[weekNumber].lessonCount, lessonByWeeks[weekNumber].quizCount);
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Course_Week/* default */.Z, {
                    weekNumber: weekNumber,
                    lessonList: lessonByWeeks[weekNumber].lessons,
                    quizCount: lessonByWeeks[weekNumber].quizCount,
                    lessonCount: lessonByWeeks[weekNumber].lessonCount,
                    onItemClick: onItemClick,
                    weekTitle: weekTitle,
                    weekInfo: weekInfo,
                    weekPlusInfoData: getWeekInfoData(weekNumber),
                    showEducatorForLesson: showEducatorForLesson,
                    isTestSeries: isTestSeries,
                    isSubscribed: isSubscribed,
                    cardPosition: cardPosition,
                    subscription: subscription,
                    forPlus: course === null || course === void 0 ? void 0 : course.forPlus,
                    courseType: course === null || course === void 0 ? void 0 : course.courseType,
                    setAnchorEl: setAnchorEl,
                    selectedLesson: selectedLesson,
                    renewalData: renewalData,
                    hasDppAccess: hasDppAccess,
                    isOnlyRecordedClassesPresent: isOnlyRecordedClassesPresent
                }, weekNumber);
            });
        }
        // show only 10 lessons if not enrolled
        var lessonShown = hideFewWeeks ? getTenLessons(allLessons) : allLessons;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Course_Week/* default */.Z, {
            weekNumber: 1,
            lessonList: lessonShown,
            quizCount: course.quizCount,
            lessonCount: course.liveClassCount,
            onItemClick: onItemClick,
            weekTitle: (course === null || course === void 0 ? void 0 : course.forPlus) ? "Schedule" : "Lessons",
            weekInfo: getCourseInfoForFreeCourse(),
            weekPlusInfoData: getScheduleInfoData(),
            showEducatorForLesson: showEducatorForLesson,
            isTestSeries: isTestSeries,
            isSubscribed: isSubscribed,
            forPlus: course === null || course === void 0 ? void 0 : course.forPlus,
            courseType: course === null || course === void 0 ? void 0 : course.courseType,
            cardPosition: cardPosition,
            subscription: subscription,
            setAnchorEl: setAnchorEl,
            selectedLesson: selectedLesson,
            renewalData: renewalData,
            hasDppAccess: hasDppAccess,
            isOnlyRecordedClassesPresent: isOnlyRecordedClassesPresent
        }, 1);
    };
    var moreLessonsAvailable = showByWeek ? !(0,isEmpty/* default */.Z)(lessonByWeeks[4]) // // if only 3 week lessons are available then do not show 'see all lessons' button
     : !(0,isEmpty/* default */.Z)(allLessons[10]); // if only 10 lessons are available then do not show 'see all lessons' button
    var seeAllText = isTestSeries ? "See all tests" : "See all lessons";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !!liveLesson.length && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Course_Week/* default */.Z, {
                weekNumber: -1,
                lessonList: liveLesson,
                weekTitle: "Live Now",
                isTestSeries: isTestSeries,
                forPlus: course === null || course === void 0 ? void 0 : course.forPlus,
                weekInfo: "Started at ".concat((0,dates/* formatTime */.mr)((liveLesson === null || liveLesson === void 0 ? void 0 : (ref1 = liveLesson[0]) === null || ref1 === void 0 ? void 0 : ref1.startedAt) || (liveLesson === null || liveLesson === void 0 ? void 0 : (ref2 = liveLesson[0]) === null || ref2 === void 0 ? void 0 : ref2.liveAt))),
                showEducatorForLesson: showEducatorForLesson,
                isSubscribed: isSubscribed,
                onItemClick: onItemClick,
                selectedLesson: selectedLesson,
                courseType: course === null || course === void 0 ? void 0 : course.courseType,
                hasDppAccess: hasDppAccess,
                isOnlyRecordedClassesPresent: isOnlyRecordedClassesPresent
            }),
            lessonToResume && !liveLesson.length && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Course_Week/* default */.Z, {
                weekNumber: 0,
                isTestSeries: isTestSeries,
                lessonList: [
                    lessonToResume
                ],
                weekTitle: "Resume",
                weekInfo: lessonToResume.type === "quiz" ? "Quiz ".concat(lessonToResume.contentRank) : "Lesson ".concat(lessonToResume.contentRank, " from ").concat((0,dates/* formatMinutesFromSeconds */._t)(lessonToResume.watchTime)),
                showEducatorForLesson: showEducatorForLesson,
                isSubscribed: isSubscribed,
                forPlus: course === null || course === void 0 ? void 0 : course.forPlus,
                courseType: course === null || course === void 0 ? void 0 : course.courseType,
                onItemClick: onItemClick,
                setAnchorEl: setAnchorEl,
                selectedLesson: selectedLesson,
                hasDppAccess: hasDppAccess,
                isOnlyRecordedClassesPresent: isOnlyRecordedClassesPresent
            }),
            renderSchedule(),
            hideFewWeeks && moreLessonsAvailable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SeeAll, {
                onClick: toggleHideWeeks,
                children: [
                    "+ ",
                    seeAllText
                ]
            })
        ]
    });
};
/* harmony default export */ var LearnerSideCourseSchdule = (LeanerCourseSchdule);

// EXTERNAL MODULE: ./src/components/Container/Course/CourseHeader/PlusCourseHeader.jsx + 24 modules
var PlusCourseHeader = __webpack_require__(23602);
;// CONCATENATED MODULE: ./src/components/Container/Course/Course.jsx





/* eslint-disable max-lines */ 













































var DppFinishSummary = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(45499), __webpack_require__.e(78788)]).then(__webpack_require__.bind(__webpack_require__, 78788));
});
var Carousel = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 81879).then(__webpack_require__.bind(__webpack_require__, 81879));
});
var Reviews = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 92194).then(__webpack_require__.bind(__webpack_require__, 33465));
});
var PlusCourseCard = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(48392), __webpack_require__.e(53360)]).then(__webpack_require__.bind(__webpack_require__, 53360));
});
var FreePlanUnlock = (0,Dynamic/* default */.Z)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 74068));
});
var FreeCourseHeader = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 97261).then(__webpack_require__.bind(__webpack_require__, 97261));
}, {
    loading: PlusHeader/* default */.Z
});
var FreeCourseCard = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 49199).then(__webpack_require__.bind(__webpack_require__, 49199));
});
var StyledCarousel = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Carousel, {
    target: "epev5s80",
    label: "StyledCarousel"
})("@media (max-width:47.95em){margin-top:80px !important;}");
var Course = function(param) {
    var courseUID = param.courseUID, isTestSeries = param.isTestSeries;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,useCourseInfo/* default */.Z)(courseUID), course = ref5.course, mutateCourseData = ref5.mutate, onToggleCourseEnroll = ref5.onToggleEnroll, isValidating = ref5.isValidating;
    var similarCourses = course_useSimilarPlusCourses(courseUID).similarCourses;
    var relevantFreeCourses = course_useRelevantFreeCourses(courseUID).relevantFreeCourses;
    var ref6 = course_useLessonList(courseUID), lessonList = ref6.lessonList, mutateLessonListData = ref6.mutate;
    var ref7 = course_useCourseTrack(courseUID), courseTrack = ref7.courseTrack, mutateNextTrack = ref7.mutate;
    var ref8 = auth_useUAM(UAM_ACTIONS.PROGRAMME_VIEW, UAM_RESOURCE_TYPES.PROGRAMME, courseUID), hasAccessToCourse = ref8.hasAccess, mutateCourseUAM = ref8.mutate;
    var selectedGoalUID = (0,useSelectedGoal/* useSelectedGoalUID */.Xm)();
    var goalUID = course.goalUid, forPlus = course.forPlus, courseType = course.courseType;
    var isHyridNonOffline = (0,selectors_course/* getIsNonOfflineHybridCourse */.Q)(course);
    var isOnlyRecordedClassesPresent = (0,selectors_course/* getIsOnlyRecordedClassesPresent */.a)(course);
    var dispatch = (0,reduxHooks/* useDispatchToStore */.Ln)();
    var ref9 = (0,react.useState)(null), anchorEl = ref9[0], setAnchorEl = ref9[1];
    var ref10 = (0,react.useState)(null), selectedLesson = ref10[0], setSelectedLesson = ref10[1];
    var ref11 = (0,react.useState)(false), freePlanUnlockDrawerState = ref11[0], setFreePlanUnlockDrawerState = ref11[1];
    var closeFreePlanUnlockDrawer = function() {
        return setFreePlanUnlockDrawerState(false);
    };
    var ref12 = (0,react.useState)(null), objectUid = ref12[0], setObjectUid = ref12[1];
    var renewalData = (0,es/* useSelector */.v9)(function(param) {
        var auth = param.auth;
        var ref;
        return (ref = auth.renewalData) === null || ref === void 0 ? void 0 : ref[goalUID];
    });
    var me = (0,es/* useSelector */.v9)(function(param) {
        var auth = param.auth;
        return auth.me;
    });
    var isLoggedIn = (0,es/* useSelector */.v9)(selectors_auth/* getIsLoggedIn */.M7);
    var reviews = (0,es/* useSelector */.v9)(function(param) {
        var paginator = param.paginator;
        var ref;
        return (ref = paginator.courseReviews) === null || ref === void 0 ? void 0 : ref[courseUID];
    });
    var goalData = (0,es/* useSelector */.v9)(function(param) {
        var topologies = param.topologies;
        return topologies.data[goalUID];
    });
    var goalName = goalData === null || goalData === void 0 ? void 0 : goalData.name;
    var isLiteUser = (0,es/* useSelector */.v9)((0,selectors_subscription/* getIsSubscribedToLite */.aA)(goalUID));
    var isPlusUser = (0,es/* useSelector */.v9)((0,selectors_subscription/* getIsSubscribedToPlus */.FZ)(goalUID));
    var isGTP = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsGTPGoal */.vf)(goalUID));
    var resumeLesson = courseTrack.nextTrack;
    var resumeQuiz = courseTrack.activeQuizSession;
    var isPlatformUnlocked = (ref = me.platformUnlockStatus) === null || ref === void 0 ? void 0 : ref.is_platform_unlocked;
    var allLessons = lessonList.results || empty/* emptyList */.n8;
    var lessonsExists = !!allLessons.length;
    var eventKeys = courseType === constants/* programmeTypes.TESTSERIES */.h7.TESTSERIES ? segment/* TEST_SERIES_KEYS */.g$8 : segment/* COURSE_KEYS */.$1X;
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    var segmentData = (0,useAllTypesOfCourseEventProps/* default */.Z)({
        course: course,
        isTesSries: courseType === constants/* programmeTypes.TESTSERIES */.h7.TESTSERIES
    });
    var ref13 = (0,useCourseClassPlayer/* default */.Z)(), openClassPlayer = ref13.open;
    var ref14 = (0,snackbar/* useSnackbar */.Ds)(), showSnackbar = ref14.open;
    var isRecordedGoal = (0,useIsRecordedGoal/* default */.Z)(goalUID);
    var setPDF = function(elem, lesson) {
        setAnchorEl(elem);
        setSelectedLesson(lesson);
    };
    var isOfflineSubscription = (0,es/* useSelector */.v9)((0,selectors_subscription/* getIsSubscribedToOffline */.ZB)(goalUID));
    var isIconicUser = (0,es/* useSelector */.v9)((0,selectors_subscription/* getIsSubscribedToIconic */.b$)(goalUID));
    var isStorePurchase = hasAccessToCourse && !(isPlusUser || isOfflineSubscription || isIconicUser);
    (0,react.useEffect)(function() {
        analytics/* segment.track */.EX.track(courseType === constants/* programmeTypes.TESTSERIES */.h7.TESTSERIES ? segment/* TEST_SERIES_VIEWED */.VSg : segment/* COURSE_VIEWED */.O25, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData, segmentData), {
            course_state: course.state,
            is_offline_course: (course === null || course === void 0 ? void 0 : course.courseType) === constants/* programmeTypes.HYBRID_COURSE */.h7.HYBRID_COURSE,
            is_offline_test_series: (course === null || course === void 0 ? void 0 : course.courseType) === constants/* programmeTypes.HYBRID_TESTSERIES */.h7.HYBRID_TESTSERIES,
            is_store_exclusive: course === null || course === void 0 ? void 0 : course.isStoreExclusive,
            educator_type: (course === null || course === void 0 ? void 0 : course.educatorType) === Batch_utils/* EDUCATOR_TYPES.PARTNER */.MB.PARTNER ? "Partner" : "Plus"
        }), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY, true, eventKeys);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (!forPlus && !(reviews === null || reviews === void 0 ? void 0 : reviews[courseUID])) {
            dispatch((0,courses/* fetchCourseReviews */.Y7)(courseUID));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        courseUID
    ]);
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            mutateCourseData();
            mutateNextTrack();
            mutateLessonListData();
            mutateCourseUAM();
        }
        if (forPlus && goalUID && isLoggedIn) {
            dispatch((0,auth/* fetchRenewalTouchPoint */.A6)(goalUID));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn,
        courseUID
    ]);
    var ref15 = (0,react.useState)(false), unEnrollModalOpen = ref15[0], setUnEnrollModalOpen = ref15[1];
    var isCompleted = (0,es/* useSelector */.v9)(function(param) {
        var courses = param.courses;
        var ref;
        return ((ref = courses.data[course.uid]) === null || ref === void 0 ? void 0 : ref.isCompleted) === 1 || course.isCompleted;
    });
    /**
   * Trigger only event if it's user initiated action.
   * @param {boolean} triggerAnalytics Should we send analytics for this event
   */ var handleRemoveFromPlanner = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var triggerAnalytics, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        triggerAnalytics = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                        dispatch((0,courses/* removeCourseFromPlanner */.fB)(courseUID));
                        if (triggerAnalytics) {
                            analytics/* segment.track */.EX.track(segment/* ADD_TO_PLANNER_REMOVED */.KEU, (0,_object_spread/* default */.Z)({}, goalSegmentData, segmentData), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY, true, eventKeys);
                        }
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleRemoveFromPlanner() {
            return _ref.apply(this, arguments);
        };
    }();
    var sendSegmentEnrollEvent = function() {
        var eventName = courseType === constants/* programmeTypes.TESTSERIES */.h7.TESTSERIES ? segment/* TEST_SERIES_ENROLLED */.k5e : segment/* COURSE_ENROLLED */.qH7;
        analytics/* segment.track */.EX.track(eventName, (0,_object_spread/* default */.Z)({}, goalSegmentData, segmentData), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY, true, eventKeys);
    };
    var ref16 = (0,toggleables/* useToggleable */.F7)(constants_toggleables/* LOGIN_DRAWER */.es), showLoginDrawer = ref16.openElement;
    var handleCourseToggle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var resp, reduxCourseEnrollToggleAction;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isLoggedIn) {
                            _ctx.next = 3;
                            break;
                        }
                        showLoginDrawer();
                        return _ctx.abrupt("return");
                    case 3:
                        if (!course.isEnrolled) {
                            _ctx.next = 6;
                            break;
                        }
                        setUnEnrollModalOpen(true);
                        return _ctx.abrupt("return");
                    case 6:
                        sendSegmentEnrollEvent();
                        _ctx.next = 9;
                        return onToggleCourseEnroll();
                    case 9:
                        resp = _ctx.sent;
                        if (!(resp === null || resp === void 0 ? void 0 : resp.error)) {
                            _ctx.next = 13;
                            break;
                        }
                        showSnackbar({
                            message: resp.error.message || "Something went wrong",
                            type: "error"
                        });
                        return _ctx.abrupt("return");
                    case 13:
                        reduxCourseEnrollToggleAction = "".concat(redux_constants/* courseTypes.TOGGLE_COURSE_ENROLLED */.Dl.TOGGLE_COURSE_ENROLLED, "_SUCCESS");
                        dispatch({
                            type: reduxCourseEnrollToggleAction,
                            enroll: true,
                            courseUID: course.uid
                        });
                        if (!isOnlyRecordedClassesPresent) {
                            showSnackbar({
                                message: isLiteUser ? constants/* staticStrings.UNENROLL_MESSAGE_FOR_LITE_COURSES */.Bc.UNENROLL_MESSAGE_FOR_LITE_COURSES : (0,constants/* getCourseEnrollMessage */.uc)({
                                    type: isTestSeries ? "Test-series" : "Course",
                                    goalUID: goalUID,
                                    selectedGoalUID: selectedGoalUID,
                                    goalName: goalName,
                                    isRecordedGoal: isRecordedGoal,
                                    isHyridNonOffline: isHyridNonOffline
                                }),
                                type: "success"
                            });
                        }
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCourseToggle() {
            return _ref.apply(this, arguments);
        };
    }();
    var sendSegmentUnEnrollEvent = function() {
        var eventName = courseType === constants/* programmeTypes.TESTSERIES */.h7.TESTSERIES ? segment/* TEST_SERIES_UNENROLLED */.NkT : segment/* COURSE_UNENROLLED */.pN9;
        analytics/* segment.track */.EX.track(eventName, (0,_object_spread/* default */.Z)({}, goalSegmentData, segmentData), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY, true, eventKeys);
    };
    var acceptOnClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var reduxCourseEnrollToggleAction;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        sendSegmentUnEnrollEvent();
                        if (!isTestSeries && isCompleted) {
                            handleRemoveFromPlanner();
                        }
                        _ctx.next = 4;
                        return onToggleCourseEnroll();
                    case 4:
                        reduxCourseEnrollToggleAction = "".concat(redux_constants/* courseTypes.TOGGLE_COURSE_ENROLLED */.Dl.TOGGLE_COURSE_ENROLLED, "_SUCCESS");
                        dispatch({
                            type: reduxCourseEnrollToggleAction,
                            enroll: false,
                            courseUID: course.uid
                        });
                        setUnEnrollModalOpen(false);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function acceptOnClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var onCloseModal = function() {
        return setUnEnrollModalOpen(false);
    };
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var onItemClick = (0,useCheckFeatureLimit/* default */.Z)(features/* FeatureType.CLASS */.T.CLASS, function() {
        var lesson = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (lesson.type === "post") {
            if ((course === null || course === void 0 ? void 0 : course.forPlus) && isLoggedIn) {
                if (isPlatformUnlocked) {
                    segmentStorage/* default.setItem */.Z.setItem("lpss", "lesson card");
                    openClassPlayer({
                        lesson: lesson,
                        course: course,
                        forceFetch: isGTP
                    });
                } else {
                    var ref;
                    setObjectUid(lesson.uid);
                    if (lesson.isSpecial || ((ref = lesson.liveClassDetails) === null || ref === void 0 ? void 0 : ref.isSpecial)) {
                        handleCourseToggle();
                    } else {
                        setFreePlanUnlockDrawerState(true);
                    }
                }
            } else if ((course === null || course === void 0 ? void 0 : course.forPlus) && !isLoggedIn) {
            // don't redirect anywhere
            } else {
                (0,pushRoute/* default */.Z)("/lesson/[lessonSlug]/[lessonUID]", "/lesson/".concat(lesson.slug, "/").concat(lesson.uid));
            }
        } else if (lesson.totalQuestions > 0) (0,pushRoute/* default */.Z)("/quiz/[quizSlug]/[quizUID]", "/quiz/".concat(lesson.slug, "/").concat(lesson.uid));
    });
    var renderHeader = function() {
        if (!course.uid) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusHeader/* default */.Z, {});
        }
        if (forPlus) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusCourseHeader/* default */.Z, {
                handleRemoveFromPlanner: handleRemoveFromPlanner,
                lessonList: lessonList,
                courseUid: course === null || course === void 0 ? void 0 : course.uid,
                course: course,
                goalUid: goalData === null || goalData === void 0 ? void 0 : goalData.uid,
                toggleEnroll: handleCourseToggle,
                isTestSeries: isTestSeries,
                isLoading: isValidating,
                isRecordedGoal: isRecordedGoal,
                hideCTA: isStorePurchase
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreeCourseHeader, {
            course: course
        });
    };
    var renderLessons = function() {
        var ref;
        if (!lessonsExists) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Schedule, {});
        }
        var lessonInfo = (0,Course_utils/* getLiveAndByWeekLessons */.UR)(allLessons);
        var lessonsCount = allLessons.length || 0;
        var showByWeek = forPlus ? ((ref = allLessons[0]) === null || ref === void 0 ? void 0 : ref.week) !== 0 && lessonsCount > 10 && lessonsCount / allLessons[lessonsCount - 1].week > 2 : false;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LearnerSideCourseSchdule, {
                    course: course,
                    isTestSeries: isTestSeries,
                    allLessons: allLessons,
                    lessonByWeeks: lessonInfo.byWeek,
                    lessonToResume: resumeQuiz || resumeLesson,
                    liveLesson: lessonInfo.liveLesson,
                    onItemClick: onItemClick,
                    setAnchorEl: setPDF,
                    selectedLesson: selectedLesson,
                    renewalData: renewalData,
                    showByWeek: showByWeek,
                    hasDppAccess: hasAccessToCourse
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DppFinishSummary, {
                    source: "Course"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog["default"], {
                onClose: onCloseModal,
                dialogState: unEnrollModalOpen,
                heading: "Are you sure you want to unenroll?",
                message: "This ".concat(isTestSeries ? "test-series" : "course", " will be removed from your schedule and you will stop receiving updates related to this course"),
                acceptLabel: "Unenroll",
                rejectLabel: "Cancel",
                acceptOnClick: acceptOnClick,
                rejectOnClick: onCloseModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu/* default */.Z, {
                anchorEl: anchorEl,
                onClose: handleClose,
                position: "right",
                width: "231px",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PDFDownload/* default */.Z, {
                    selectedLesson: selectedLesson,
                    handleClose: handleClose,
                    me: me,
                    source: "learnerCoursePage",
                    course: course,
                    goal: goalData
                })
            }),
            renderHeader(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoClasses/* default */.Z, {
                apiKey: (0,useDemoClasses/* getCourseDemoClassesKey */.wO)(courseUID),
                goalUID: goalUID
            }),
            renderLessons(),
            (similarCourses === null || similarCourses === void 0 ? void 0 : similarCourses.data) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCarousel, {
                label: ((ref1 = similarCourses.extraBlockinfo) === null || ref1 === void 0 ? void 0 : ref1.title) || "Similar Courses",
                showControls: false,
                numberOfItems: 4,
                gridColumn: "span 24",
                children: (ref2 = similarCourses.data) === null || ref2 === void 0 ? void 0 : ref2.map(function(courseData) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusCourseCard, {
                        gridColumn: "span 6/ auto",
                        course: courseData,
                        dataAnalytics: "course-courseEnroll",
                        newTab: true
                    }, courseData.uid);
                })
            }, ((ref3 = similarCourses.extraBlockinfo) === null || ref3 === void 0 ? void 0 : ref3.title) || "Similar Courses"),
            (reviews === null || reviews === void 0 ? void 0 : (ref4 = reviews.results) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reviews, {
                course: course,
                reviews: reviews
            }),
            !!relevantFreeCourses.length && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCarousel, {
                label: "Similar courses",
                showControls: false,
                numberOfItems: 4,
                gridColumn: "span 24",
                children: relevantFreeCourses.map(function(freeCourse) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreeCourseCard, {
                        gridColumn: "span 6/ auto",
                        course: freeCourse
                    }, freeCourse.uid);
                })
            }, "Similar courses"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreePlanUnlock, {
                drawerState: freePlanUnlockDrawerState,
                closeDrawerHandler: closeFreePlanUnlockDrawer,
                objectType: constants/* unlockFreePlanFor.SPECIAL_CLASS */.uZ.SPECIAL_CLASS,
                objectUid: objectUid,
                callBack: function() {
                    setTimeout(function() {
                        return setFreePlanUnlockDrawerState(false);
                    }, 3000);
                    handleCourseToggle();
                }
            })
        ]
    });
};
/* harmony default export */ var Course_Course = (Course);

// EXTERNAL MODULE: ./src/seo/index.jsx + 2 modules
var seo = __webpack_require__(14432);
// EXTERNAL MODULE: ./src/seo/course/course.js
var course_course = __webpack_require__(86965);
// EXTERNAL MODULE: ./src/utils/cookies.js
var cookies = __webpack_require__(18113);
// EXTERNAL MODULE: ./src/layout/index.jsx + 26 modules
var layout = __webpack_require__(41566);
// EXTERNAL MODULE: ./src/components/Container/App/PageReduxProviderWrapper.jsx
var PageReduxProviderWrapper = __webpack_require__(27300);
// EXTERNAL MODULE: ./src/components/Analytics/OneLinkSmartScript.jsx
var OneLinkSmartScript = __webpack_require__(92588);
;// CONCATENATED MODULE: ./src/pages/course/[slug]/[courseUID].jsx


/* ==== Course page is cached on cdn for 1 hours ==== */ 






















var CoursePageWithSEO = function() {
    var ref = (0,next_router.useRouter)(), courseUID = ref.query.courseUID;
    var course = (0,useCourseInfo/* default */.Z)(courseUID).course;
    var fetchingUserData = (0,es/* useSelector */.v9)(selectors_auth/* getIsFetchingUserData */.r$);
    var ref1 = (0,toggleables/* useToggleable */.F7)(constants_toggleables/* LOGIN_DRAWER */.es), openLoginDrawer = ref1.openElement;
    (0,react.useEffect)(function() {
        if (!course.uid) {
            if (!(0,cookies/* readCookie */.vQ)("accessToken") && !fetchingUserData) {
                openLoginDrawer();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _name = course.name, name = _name === void 0 ? "" : _name, description = course.description, slug = course.slug, uid = course.uid, isPublic = course.isPublic, thumbnail = course.thumbnail, coverPhoto = course.coverPhoto, ogImage = course.ogImage, authors = course.authors, language = course.language, _goal = course.goal, goal = _goal === void 0 ? empty/* emptyObject */.FD : _goal;
    var metaTitle = "".concat(goal.name || "Course", " - ").concat(name, " by Unacademy");
    var metaDescription = "Enrol for ".concat(goal.name || "Course", " ").concat(name, " conducted by ").concat((0,textHelper/* wordsToSentence */.nt)(authors, "name", ",", ","), " on Unacademy. The course is taught in ").concat(language, ".");
    var url = slug && uid ? "https://unacademy.com/course/".concat(slug, "/").concat(uid) : null;
    var schema = uid && isPublic ? (0,course_course/* default */.Z)(goal, description, course) : null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo/* default */.Z, {
                title: metaTitle,
                url: url,
                description: metaDescription,
                openGraph: {
                    title: metaTitle,
                    metaDescription: metaDescription,
                    images: [
                        {
                            url: ogImage || thumbnail || coverPhoto
                        }
                    ],
                    url: url
                },
                schema: schema
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Course_Course, {
                courseUID: courseUID
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneLinkSmartScript/* default */.Z, {})
        ]
    });
};
var CourseWithSWRConfig = function(param) {
    var courseUID = param.courseUID, courseFallbackData = param.courseFallbackData, lessonListFallbackData = param.lessonListFallbackData, similarPlusCoursesFallbackData = param.similarPlusCoursesFallbackData, relevantFreeCoursesFallbackData = param.relevantFreeCoursesFallbackData, demoClasses = param.demoClasses;
    var courseInfokey = (0,useCourseInfo/* getKey */.k)(courseUID);
    var lessonListKey = useLessonList_getKey(courseUID);
    var similarPlusCoursesKey = getKey(courseUID);
    var relevantFreeCoursesKey = useRelevantFreeCourses_getKey(courseUID);
    var demoClassesKey = (0,useDemoClasses/* getCourseDemoClassesKey */.wO)(courseUID);
    var accessToken = (0,cookies/* readCookie */.vQ)("accessToken");
    var _obj;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* SWRConfig */.J$, {
        value: {
            revalidateOnMount: !!accessToken,
            dedupingInterval: 60 * 1000,
            fallback: (_obj = {}, (0,_define_property/* default */.Z)(_obj, courseInfokey, courseFallbackData), (0,_define_property/* default */.Z)(_obj, similarPlusCoursesKey, similarPlusCoursesFallbackData), (0,_define_property/* default */.Z)(_obj, lessonListKey, (0,utils/* processLessonList */.jl)(lessonListFallbackData)), (0,_define_property/* default */.Z)(_obj, relevantFreeCoursesKey, relevantFreeCoursesFallbackData), (0,_define_property/* default */.Z)(_obj, demoClassesKey, demoClasses), _obj)
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CoursePageWithSEO, {
            courseUID: courseUID
        })
    });
};
CourseWithSWRConfig.pageInfo = {
    name: segment/* COURSE_PAGE */.VyX,
    layoutOptions: {
        hideIntercom: true,
        hideFreshbot: true
    },
    isMWebSupported: true
};
var __N_SSG = true;
/* harmony default export */ var _courseUID_ = (CourseWithSWRConfig);
CourseWithSWRConfig.Layout = layout/* default */.Z;
CourseWithSWRConfig.Wrapper = PageReduxProviderWrapper["default"];


/***/ }),

/***/ 20717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hv": function() { return /* binding */ fetchCommunityPageData; },
/* harmony export */   "JV": function() { return /* binding */ fetchPriceHikeInfo; },
/* harmony export */   "b_": function() { return /* binding */ fetchSubscriptionFaqs; },
/* harmony export */   "cT": function() { return /* binding */ uploadFile; },
/* harmony export */   "fK": function() { return /* binding */ saveProdigyAdditionalData; },
/* harmony export */   "jl": function() { return /* binding */ setFetchStateOfScheduleDataForDpp; },
/* harmony export */   "jo": function() { return /* binding */ setPreviewModeInRedux; },
/* harmony export */   "mu": function() { return /* binding */ fetchS3SignInUrl; },
/* harmony export */   "rv": function() { return /* binding */ fetchSubscriptionFeatures; }
/* harmony export */ });
/* unused harmony exports fetchFaqs, submitIssue, fetchLegendsBanner, fetchIconicSubscriptionInfo, fetchSubscriptionHighlights, fetchOneCarouselFeed, fetchRootPageData, fetchGoalDisplayNames, fetchProdigyPageData, verifyUserProdigyDetails, setEnrolledCourse, predictExamRank */
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54051);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94336);
/* harmony import */ var _schemas__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38037);




var fetchFaqs = function() {
    return {
        type: otherTypes.FETCH_FAQS,
        endpoint: "v1/faq/?type=2",
        method: "get"
    };
};
var fetchS3SignInUrl = function(fileName) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, uid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", contentType = arguments.length > 3 ? arguments[3] : void 0;
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .otherTypes.FETCH_S3_SIGNIN_URL */ .vK.FETCH_S3_SIGNIN_URL,
        endpoint: "v1/s3_url/?objectName=".concat(encodeURIComponent(fileName), "&type=").concat(type).concat(uid ? "&uid=".concat(uid) : "").concat(contentType ? "&contentType=".concat(contentType) : ""),
        method: "get"
    };
};
var submitIssue = function(data) {
    return {
        type: otherTypes.SUBMIT_ISSUE,
        endpoint: "v1/user/me/report_bug/",
        method: "post",
        data: data
    };
};
var fetchLegendsBanner = function() {
    return {
        type: otherTypes.FETCH_LEGENDS_BANNER,
        endpoint: "v1/feeds/banners/",
        method: "get"
    };
};
var fetchIconicSubscriptionInfo = function(key) {
    return {
        type: otherTypes.FETCH_ICONIC_SUBSCRIPTION_INFO,
        endpoint: "subscription-info/".concat(key),
        method: "get",
        iconicKey: key,
        hostType: HOST_TYPE.CMS
    };
};
var fetchSubscriptionFeatures = function(key) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .otherTypes.FETCH_SUBSCRIPTION_FEATURES */ .vK.FETCH_SUBSCRIPTION_FEATURES,
        endpoint: "subscription-features/".concat(key),
        method: "get",
        hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__/* .HOST_TYPE.CMS */ .Bk.CMS
    };
};
var fetchSubscriptionHighlights = function(key) {
    return {
        type: otherTypes.FETCH_SUBSCRIPTION_HIGHLIGHTS,
        endpoint: "subscription-highlights/".concat(key),
        method: "get",
        hostType: HOST_TYPE.CMS
    };
};
var fetchPriceHikeInfo = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .otherTypes.FETCH_PRICE_HIKE_INFO */ .vK.FETCH_PRICE_HIKE_INFO,
        endpoint: "active-price-hikes",
        method: "get",
        hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__/* .HOST_TYPE.CMS */ .Bk.CMS
    };
};
var fetchSubscriptionFaqs = function(key) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .otherTypes.FETCH_SUBSCRIPTION_FAQS */ .vK.FETCH_SUBSCRIPTION_FAQS,
        endpoint: "subscription-faqs/".concat(key),
        method: "get",
        hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__/* .HOST_TYPE.CMS */ .Bk.CMS
    };
};
var fetchOneCarouselFeed = function() {
    return {
        type: otherTypes.FETCH_ONE_CAROUSEL_FEED,
        endpoint: "v1/feeds/carousel",
        method: "get",
        entityType: "feedrow",
        schema: paginatorResultsSchema
    };
};
var fetchRootPageData = function() {
    return {
        type: otherTypes.FETCH_ROOT_PAGE_DATA,
        endpoint: "api/root-page",
        method: "get",
        hostType: HOST_TYPE.CMS
    };
};
var fetchGoalDisplayNames = function() {
    return {
        type: otherTypes.FETCH_GOAL_DISPLAY_NAMES,
        endpoint: "api/goal-display-names",
        method: "get",
        hostType: HOST_TYPE.CMS
    };
};
var uploadFile = function(url, file_name) {
    var doc_type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .s3BucketTypes.LEARNER_NOTES */ .Ud.LEARNER_NOTES;
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .otherTypes.UPLOAD_FILE */ .vK.UPLOAD_FILE,
        endpoint: "v1/uploads/document/",
        method: "post",
        data: {
            url: url,
            file_name: file_name,
            doc_type: doc_type
        }
    };
};
var setPreviewModeInRedux = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .otherTypes.SET_PREVIEW_MODE */ .vK.SET_PREVIEW_MODE
    };
};
var fetchProdigyPageData = function(eventKey) {
    return {
        type: otherTypes.FETCH_PRODIGY_DATA,
        endpoint: "api/prodigy-tests/".concat(eventKey),
        method: "get",
        hostType: HOST_TYPE.CMS
    };
};
var verifyUserProdigyDetails = function(eventKey) {
    return {
        type: otherTypes.VERIFY_PRODIGY_DETAILS,
        endpoint: "v1/uplus/prodigy_user/details/?prodigy_key=".concat(eventKey),
        method: "get"
    };
};
var saveProdigyAdditionalData = function(payload) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .otherTypes.SAVE_PRODIGY_ADDITIONAL_DATA */ .vK.SAVE_PRODIGY_ADDITIONAL_DATA,
        endpoint: "v1/uplus/prodigy_user/save/",
        method: "post",
        data: payload
    };
};
var setEnrolledCourse = function(eventUID) {
    return {
        type: otherTypes.SET_SAVED_COURSE,
        eventUID: eventUID
    };
};
var predictExamRank = function(examUID, data) {
    return {
        type: otherTypes.PREDICT_EXAM_RANK,
        endpoint: "v1/exam/".concat(examUID, "/predict_rank/"),
        method: "post",
        data: data,
        hostType: HOST_TYPE.TEST_SERIES
    };
};
var fetchCommunityPageData = function() {
    return {
        types: _constants__WEBPACK_IMPORTED_MODULE_2__/* .otherTypes.FETCH_COMMUNITY_STATIC_DATA */ .vK.FETCH_COMMUNITY_STATIC_DATA,
        endpoint: "api/policies/communityStatic",
        method: "get",
        hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__/* .HOST_TYPE.CMS */ .Bk.CMS
    };
};
var setFetchStateOfScheduleDataForDpp = function(data) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .otherTypes.SET_FETCH_STATE_OF_SCHEDULE_DATA_FOR_DPP */ .vK.SET_FETCH_STATE_OF_SCHEDULE_DATA_FOR_DPP,
        data: data
    };
};


/***/ }),

/***/ 75982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gp": function() { return /* binding */ isScheduleDataForDppFetched; },
/* harmony export */   "nB": function() { return /* binding */ getPreviewMode; }
/* harmony export */ });
/* unused harmony exports getSnackBarContent, getSubscriptionFeatures, getSubscriptionHighlights, getIconicFAQs */
var getSnackBarContent = function(param) {
    var others = param.others;
    return others.snackBarContent;
};
var getPreviewMode = function(param) {
    var others = param.others;
    return others.nextPreviewMode || false;
};
var isScheduleDataForDppFetched = function(param) {
    var others = param.others;
    return others === null || others === void 0 ? void 0 : others.isScheduleDataForDppFetched;
};
var getSubscriptionFeatures = function(param) {
    var others = param.others;
    return others.subscriptionFeatures;
};
var getSubscriptionHighlights = function(param) {
    var others = param.others;
    return others.subscriptionHighlights;
};
var getIconicFAQs = function(param) {
    var others = param.others;
    return others.iconicFAQs;
};


/***/ }),

/***/ 83109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CD": function() { return /* binding */ getHasTopologyInfo; },
/* harmony export */   "Cl": function() { return /* binding */ getTopologyCoursesCount; },
/* harmony export */   "NF": function() { return /* binding */ getIsNoTestGoal; },
/* harmony export */   "OQ": function() { return /* binding */ getTopologySlug; },
/* harmony export */   "Qz": function() { return /* binding */ getGoalInfoByUIDFromData; },
/* harmony export */   "dH": function() { return /* binding */ getTopologyOrEmptyObject; },
/* harmony export */   "e1": function() { return /* binding */ getGoalInfoByUID; },
/* harmony export */   "gc": function() { return /* binding */ getTopologyPlusCoursesCount; },
/* harmony export */   "hP": function() { return /* binding */ getTopology; },
/* harmony export */   "qp": function() { return /* binding */ getTopologyDataByUID; },
/* harmony export */   "uc": function() { return /* binding */ getExternalAppsAvailable; },
/* harmony export */   "vo": function() { return /* binding */ getTopologyParentName; },
/* harmony export */   "w6": function() { return /* binding */ getTopologyOnboardingGoals; },
/* harmony export */   "x4": function() { return /* binding */ getTopologyUpcomingCoursesCountThisMonth; },
/* harmony export */   "xm": function() { return /* binding */ getIsSyllabusV1Enabled; },
/* harmony export */   "xr": function() { return /* binding */ getIsTopologySelfDataFetched; },
/* harmony export */   "yb": function() { return /* binding */ getTopologyName; }
/* harmony export */ });
/* unused harmony exports getTopologiesGoalLanguages, getTopologiesList, getTopologyColor, getOnboardingPreferencesUpdated, getIsCatalogueFeatureAvailable, getIsPlusAvailable, getIsPracticeAvailable, getIsRecordedGoal, getTopologyGoalBenefitsByKey, getPreSubscribedStaticData, getPlatformBenefits, getIsPlatformGoalEnabled, getGoalSynonyms, getHideNudge */
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59375);

var getTopologies = function(state) {
    return state.topologies;
};
var _goalLanguages;
var getTopologiesGoalLanguages = function(state) {
    return (_goalLanguages = getTopologies(state).goalLanguages) !== null && _goalLanguages !== void 0 ? _goalLanguages : emptyList;
};
var getTopologyDataByUID = function(goalUID) {
    return function(state) {
        return getTopologies(state).data[goalUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD;
    };
};
var getTopologiesList = function(state) {
    return getTopologies(state).data;
};
var getTopologyInfo = function(state, goalUID) {
    return getTopologies(state).data[goalUID];
};
var getTopologyInfoOrEmptyObject = function(state, goalUID) {
    return getTopologyInfo(state, goalUID) || emptyObject;
};
var getTopologyColor = function(state, goalUID) {
    return getTopologyInfoOrEmptyObject(state, goalUID).colorCode;
};
var getOnboardingPreferencesUpdated = function(goalUID) {
    return function(state) {
        return getTopologies(state).areGoalOnBoardingPreferencesUpdated[goalUID] || false;
    };
};
var getTopology = function(state, uid) {
    return state.topologies.data[uid];
};
var getHasTopologyInfo = function(state, uid) {
    return !!getTopology(state, uid);
};
var getTopologyOrEmptyObject = function(state, uid) {
    return getTopology(state, uid) || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD;
};
var getTopologyName = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).name || "";
};
var getTopologyCoursesCount = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).coursesCount;
};
var getTopologyUpcomingCoursesCountThisMonth = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).upcomingCoursesThisMonth;
};
var getIsNoTestGoal = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isNoTestGoal;
};
var getIsCatalogueFeatureAvailable = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isCatalogueFeatureAvailable || false;
};
var getIsPlusAvailable = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isPlusAvailable || false;
};
var getIsPracticeAvailable = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isPracticeAvailable || false;
};
var getIsRecordedGoal = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isRecordedGoal || false;
};
var getTopologySlug = function(state, uid) {
    var topology = getTopologyOrEmptyObject(state, uid);
    return topology.goalSlug || topology.slug;
};
var getExternalAppsAvailable = function(state, uid) {
    var ref, ref1;
    return ((ref = getTopology(state, uid)) === null || ref === void 0 ? void 0 : ref.externalApps) || ((ref1 = getTopology(state, uid)) === null || ref1 === void 0 ? void 0 : ref1.externalAppsAvailable);
};
var getTopologyPlusCoursesCount = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).plusCourseCount;
};
var getIsTopologySelfDataFetched = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).selfDataFetched;
};
var getTopologyParent = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).parent || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD;
};
var getTopologyParentName = function(state, uid) {
    return getTopologyParent(state, uid).name || "";
};
var _key;
var getTopologyGoalBenefitsByKey = function(key) {
    return function(param) {
        var topologies = param.topologies;
        return (_key = topologies.goalBenefits[key]) !== null && _key !== void 0 ? _key : {};
    };
};
var getGoalInfoByUID = function(param, goalUID) {
    var topologies = param.topologies;
    return topologies.topologyDetails[goalUID];
};
var getPreSubscribedStaticData = function(goalUID) {
    return function(param) {
        var topologies = param.topologies;
        return topologies.preSubscribedStaticContent[goalUID];
    };
};
var getGoalInfoByUIDFromData = function(state, goalUID) {
    return state.topologies.data[goalUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD;
};
var getTopologyOnboardingGoals = function(param) {
    var topologies = param.topologies;
    return topologies.onboardingGoals;
};
var getPlatformBenefits = function(goalUID) {
    return function(param) {
        var topologies = param.topologies;
        return topologies === null || topologies === void 0 ? void 0 : topologies.platformGoalBenefits[goalUID];
    };
};
var getIsSyllabusV1Enabled = function(state, goalUID) {
    return getTopologyOrEmptyObject(state, goalUID).isSyllabusV1Enabled || false;
};
var getIsPlatformGoalEnabled = function(state, goalUID) {
    return getTopologyOrEmptyObject(state, goalUID).isPlatformGoal || false;
};
var getGoalSynonyms = function(param) {
    var topologies = param.topologies;
    return topologies === null || topologies === void 0 ? void 0 : topologies.goalSynonyms;
};
var getHideNudge = function(goalUID) {
    return function(state) {
        var ref;
        return ((ref = getTopologyOrEmptyObject(state, goalUID).goalLevelOnboarding) === null || ref === void 0 ? void 0 : ref.hideNudge) || true;
    };
};


/***/ }),

/***/ 86965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _seo_schemas_breadcrumb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29630);
/* harmony import */ var _schemas_course__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50757);


var courseSchema = function() {
    var goal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, description = arguments.length > 1 ? arguments[1] : void 0, course = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var graph = [];
    if (course.name) {
        graph.push((0,_schemas_course__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(course));
    }
    var breads = [
        {
            url: "https://unacademy.com/explore",
            name: "Explore"
        }
    ];
    if (goal.permalink && goal.name) breads.push({
        url: goal.permalink,
        name: goal.name
    });
    if (course.permalink && course.name) breads.push({
        url: course.permalink,
        name: course.name
    });
    graph.push((0,_seo_schemas_breadcrumb__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(breads));
    var schema = {
        "@context": "https://schema.org/",
        "@graph": graph
    };
    return schema;
};
/* harmony default export */ __webpack_exports__["Z"] = (courseSchema);


/***/ }),

/***/ 29630:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var breadCrumbSchema = function(breads) {
    var schema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList"
    };
    schema.itemListElement = breads.filter(function(bread) {
        return bread.name && bread.url;
    }).map(function(bread, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            name: bread.name,
            item: bread.url
        };
    });
    return schema;
};
/* harmony default export */ __webpack_exports__["Z"] = (breadCrumbSchema);


/***/ }),

/***/ 50757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97428);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31309);


var creators = function(authors) {
    if (Array.isArray(authors)) {
        return authors.map(function(author) {
            return {
                "@type": "Person",
                name: author.name || "".concat(author.firstName, " ").concat(author.lastName)
            };
        });
    }
    return {
        "@type": "Person",
        name: authors.name
    };
};
function courseSchema(course) {
    var thumbnail = course.thumbnail, topic = course.topic, name = course.name, authors = course.authors, author = course.author, description = course.description, permalink = course.permalink, forPlus = course.forPlus, _goal = course.goal, goal = _goal === void 0 ? {} : _goal, coverPhoto = course.coverPhoto, uid = course.uid, language = course.language, languages = course.languages;
    if (!goal) return null;
    var authorInfo = authors ? authors[0] : author !== null && author !== void 0 ? author : {};
    return {
        "@context": "https://schema.org/",
        "@type": "Course",
        image: coverPhoto || thumbnail,
        courseCode: uid,
        accessMode: [
            "auditory",
            "visual"
        ],
        url: permalink,
        thumbnailUrl: coverPhoto || thumbnail,
        provider: {
            "@type": "Organization",
            name: (authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) || "".concat(authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.firstName, " ").concat(authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.lastName),
            sameAs: "https://unacademy.com/@".concat(authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.username)
        },
        about: {
            name: topic
        },
        audience: {
            audienceType: [
                "Anyone Prepearing for ".concat(goal.name)
            ],
            "@type": "Audience"
        },
        name: name,
        inLanguage: language || (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .wordsToSentence */ .nt)(languages, "label", ", ", ", "),
        publisher: {
            "@type": "Organization",
            name: "Unacademy",
            sameAs: "https://unacademy.com/"
        },
        description: (description || "").replace(/</g, "< ").replace(/>/g, " >"),
        "@id": permalink,
        creator: creators(authors || author),
        isAccessibleForFree: forPlus ? "http://schema.org/False" : "http://schema.org/True",
        hasCourseInstance: [
            {
                "@type": "CourseInstance",
                courseMode: [
                    "Online",
                    "Distance Learning"
                ],
                startDate: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getDate */ ._3)(course.startsAt)
            }
        ]
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (courseSchema);


/***/ }),

/***/ 78758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getExperimentVariation; }
/* harmony export */ });
/* unused harmony export getExperimentVariationSetter */
/* eslint-disable import/prefer-default-export */ var getExperimentVariation = function(experimentName) {
    return function(state) {
        return state.experimentVariations[experimentName] || null;
    };
};
var getExperimentVariationSetter = function(state) {
    return state.setExperimentVariations;
};


/***/ }),

/***/ 36414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ FeatureType; }
/* harmony export */ });
var FeatureType;
(function(FeatureType) {
    FeatureType[FeatureType["CLASS"] = 1] = "CLASS";
})(FeatureType || (FeatureType = {}));


/***/ }),

/***/ 51562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _actions_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68060);
/* harmony import */ var _stores_toggleables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85690);
/* harmony import */ var _stores_snackbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97296);
/* harmony import */ var _constants_toggleables__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28119);
/* harmony import */ var _actions_constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94336);
/* harmony import */ var _utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74392);
/* harmony import */ var _api_fetchers_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79415);
/* harmony import */ var _getTokens__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17912);
/* harmony import */ var _captureAPIFailure__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28029);













var isRefreshing = false;
var subscribers = [];
var fetchErrorHandler = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var error, _action, action, dispatch, getState, _rest, rest, options, headers, endpoint, source, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, accessToken, refreshToken, isServer, response, errorResp;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    error = param.error, _action = param.action, action = _action === void 0 ? {
                        type: ""
                    } : _action, dispatch = param.dispatch, getState = param.getState, _rest = param.rest, rest = _rest === void 0 ? {} : _rest, options = param.options, headers = param.headers, endpoint = param.endpoint, source = param.source;
                    ;
                    if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) >= 400 && (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) < 600) (0,_captureAPIFailure__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        endpoint: endpoint,
                        error: error,
                        source: source,
                        options: options,
                        headers: headers
                    });
                    if (!((error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 401)) {
                        _ctx.next = 35;
                        break;
                    }
                    ref7 = (0,_getTokens__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(getState), accessToken = ref7.accessToken, refreshToken = ref7.refreshToken;
                    isServer = "object" === "undefined";
                    if (!(accessToken && refreshToken)) {
                        _ctx.next = 34;
                        break;
                    }
                    if (isRefreshing) {
                        _ctx.next = 32;
                        break;
                    }
                    if (action.type !== "ME") subscribers.push(action);
                    isRefreshing = true;
                    _ctx.prev = 10;
                    _ctx.next = 13;
                    return (0,_api_fetchers_user__WEBPACK_IMPORTED_MODULE_6__/* .fetchNewToken */ .R$)(refreshToken);
                case 13:
                    _ctx.next = 15;
                    return _ctx.sent.json();
                case 15:
                    response = _ctx.sent;
                    if (!(response === null || response === void 0 ? void 0 : response.error)) {
                        _ctx.next = 18;
                        break;
                    }
                    throw new Error(response === null || response === void 0 ? void 0 : response.error);
                case 18:
                    isRefreshing = false;
                    dispatch((0,_actions_auth__WEBPACK_IMPORTED_MODULE_1__/* .authenticate */ .YR)({
                        accessToken: response.access_token,
                        refreshToken: response.refresh_token
                    }));
                    _ctx.next = 22;
                    return dispatch((0,_actions_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchMyInfo */ .ct)());
                case 22:
                    subscribers.forEach(function(cb) {
                        return dispatch(cb);
                    });
                    _ctx.next = 29;
                    break;
                case 25:
                    _ctx.prev = 25;
                    _ctx.t0 = _ctx["catch"](10);
                    if (!isServer) {
                        (0,_utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("", {
                            keepSelectedGoal: true
                        });
                        (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_2__/* .openToggleableElement */ .SL)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_10__/* .LOGIN_DRAWER */ .es);
                    }
                    dispatch({
                        type: "".concat(_actions_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .authTypes.ME */ .CK.ME, "_FAILURE")
                    });
                case 29:
                    _ctx.prev = 29;
                    subscribers = [];
                    return _ctx.finish(29);
                case 32:
                    _ctx.next = 35;
                    break;
                case 34:
                    {
                        if (!isServer) {
                            (0,_utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("", {
                                keepSelectedGoal: true
                            });
                            (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_2__/* .openToggleableElement */ .SL)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_10__/* .LOGIN_DRAWER */ .es);
                        }
                        dispatch({
                            type: "".concat(_actions_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .authTypes.ME */ .CK.ME, "_FAILURE")
                        });
                    }
                case 35:
                    if ((error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 429) {
                        _stores_snackbar__WEBPACK_IMPORTED_MODULE_3__/* .utils.open */ .P6.open({
                            message: "Too many requests. Please try again after sometime.",
                            type: "error"
                        });
                    }
                    if (!((error === null || error === void 0 ? void 0 : (ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) >= 500 || error.status >= 500)) {
                        _ctx.next = 38;
                        break;
                    }
                    return _ctx.abrupt("return", dispatch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, rest), {
                        error: error,
                        type: "".concat(action.type, "_FAILURE")
                    })));
                case 38:
                    _ctx.next = 40;
                    return error === null || error === void 0 ? void 0 : (ref5 = error.response) === null || ref5 === void 0 ? void 0 : ref5.json();
                case 40:
                    errorResp = _ctx.sent;
                    return _ctx.abrupt("return", dispatch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, rest), {
                        error: errorResp,
                        type: "".concat(action.type, "_FAILURE"),
                        statusCode: error === null || error === void 0 ? void 0 : (ref6 = error.response) === null || ref6 === void 0 ? void 0 : ref6.status
                    })));
                case 42:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                10,
                25,
                29,
                32
            ]
        ]);
    }));
    return function fetchErrorHandler(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (fetchErrorHandler);


/***/ }),

/***/ 2477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var camelcase_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12828);
/* harmony import */ var camelcase_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(camelcase_keys__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _checkAPIResponseStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89875);




/**
 * Fetch with response status check.
 * This function must be wrapped in a try/catch block to catch exceptions.
 * Being used in **worker** space as well.
 * @param {string} url
 * @param {object} options
 * @returns {*} any
 */ var fetchWithoutErrorHandling = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, options) {
        var ref, headers, _useCamelCase, useCamelCase, _hasTextResponse, hasTextResponse, _requestType, requestType, _isFormData, isFormData, _body, body, fetchOptions, response, resp;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = options || {}, headers = ref.headers, _useCamelCase = ref.useCamelCase, useCamelCase = _useCamelCase === void 0 ? false : _useCamelCase, _hasTextResponse = ref.hasTextResponse, hasTextResponse = _hasTextResponse === void 0 ? false : _hasTextResponse, _requestType = ref.requestType, requestType = _requestType === void 0 ? "GET" : _requestType, _isFormData = ref.isFormData, isFormData = _isFormData === void 0 ? false : _isFormData, _body = ref.body, body = _body === void 0 ? null : _body;
                    fetchOptions = {
                        method: requestType,
                        headers: headers || {},
                        credentials: "same-origin"
                    };
                    if (false) {}
                    if (body) {
                        try {
                            fetchOptions.body = isFormData ? body : JSON.stringify(body);
                        } catch (e) {
                        /* */ }
                    }
                    _ctx.next = 6;
                    return fetch(url, fetchOptions);
                case 6:
                    response = _ctx.sent;
                    (0,_checkAPIResponseStatus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(response);
                    if (!(response.status === 204)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", response);
                case 10:
                    ;
                    if (hasTextResponse) {
                        _ctx.next = 23;
                        break;
                    }
                    _ctx.prev = 12;
                    _ctx.next = 15;
                    return response.json();
                case 15:
                    resp = _ctx.sent;
                    if (useCamelCase) resp = camelcase_keys__WEBPACK_IMPORTED_MODULE_1___default()(resp, {
                        deep: true
                    });
                    _ctx.next = 21;
                    break;
                case 19:
                    _ctx.prev = 19;
                    _ctx.t0 = _ctx["catch"](12);
                case 21:
                    _ctx.next = 26;
                    break;
                case 23:
                    _ctx.next = 25;
                    return response.text();
                case 25:
                    resp = _ctx.sent;
                case 26:
                    return _ctx.abrupt("return", resp);
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                12,
                19
            ]
        ]);
    }));
    return function fetchWithoutErrorHandling(url, options) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (fetchWithoutErrorHandling);


/***/ }),

/***/ 26951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54051);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34497);
/* harmony import */ var _utils_deviceHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97487);
/* harmony import */ var _getTokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17912);






var defaultHost = (0,_utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultHost */ .tW)();
var getHeaders = function(param) {
    var url = param.url, getState = param.getState, _headersOptions = param.headersOptions, _useAuthToken = _headersOptions.useAuthToken, useAuthToken = _useAuthToken === void 0 ? true : _useAuthToken, _useSearchToken = _headersOptions.useSearchToken, useSearchToken = _useSearchToken === void 0 ? false : _useSearchToken, _useJWTToken = _headersOptions.useJWTToken, useJWTToken = _useJWTToken === void 0 ? false : _useJWTToken, _isFormData = _headersOptions.isFormData, isFormData = _isFormData === void 0 ? false : _isFormData, _useStarGateToken = _headersOptions.useStarGateToken, useStarGateToken = _useStarGateToken === void 0 ? false : _useStarGateToken, headers = param.headers;
    var ref = (0,_getTokens__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(getState), accessToken = ref.accessToken, searchToken = ref.searchToken, JWTToken = ref.JWTToken;
    var apiCallHeaders = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, useAuthToken && accessToken ? {
        authorization: "Bearer ".concat(accessToken)
    } : "", useJWTToken && JWTToken ? {
        authorization: "Bearer ".concat(JWTToken)
    } : "", useSearchToken && searchToken ? {
        searchToken: "Bearer ".concat(searchToken)
    } : "", !isFormData && {
        "Content-Type": "application/json"
    }, headers || {});
    var isServer = "object" === "undefined";
    if (url.includes(defaultHost)) {
        var platform = !isServer && _utils_deviceHelper__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isMobile */ .Z.isMobile({
            isServer: isServer
        }) ? _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PLATFORM.MOBILE */ .iw.MOBILE : _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PLATFORM.OTHER */ .iw.OTHER;
        apiCallHeaders["X-Platform"] = platform;
    }
    if (useStarGateToken) {
        var stargateJWTToken = (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_2__/* .getStargateJwtToken */ .$1)(getState());
        apiCallHeaders["Stargate-Token"] = stargateJWTToken;
    }
    return apiCallHeaders;
};
/* harmony default export */ __webpack_exports__["Z"] = (getHeaders);


/***/ }),

/***/ 17912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18113);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34497);


var getTokens = function(getState) {
    var accessToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("accessToken", getState);
    var refreshToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("refreshToken", getState);
    if (true) {
        if (!accessToken) accessToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("accessToken");
        if (!refreshToken) refreshToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("refreshToken");
    }
    var searchToken = typeof getState === "function" ? (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getSearchToken */ .d6)(getState()) : "";
    var JWTToken = (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getJwtToken */ .rS)(getState());
    return {
        accessToken: accessToken,
        refreshToken: refreshToken,
        searchToken: searchToken,
        JWTToken: JWTToken
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getTokens);


/***/ }),

/***/ 21848:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var parseNumber = function(value) {
    var radix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return value && parseInt(value, radix) || 0;
};
/* harmony default export */ __webpack_exports__["Z"] = (parseNumber);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [53662,35303,86924,82492,52420,25675,96523,61608,41664,63953,74635,21322,74061,84872,55169,868,99943,16766,42298,23329,86985,80555,38059,31217,20308,9720,16050,4392,72047,56015,41566,13237,77566,94774,7346,99164,63492,95141,24015,49774,92888,40179], function() { return __webpack_exec__(45146); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);